/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** @format int32 */
export enum WeekDay {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
}

/** @format int32 */
export enum WalkInPaymentMethod {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
}

/** @format int32 */
export enum VerificationStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum TransactionType {
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum TransactionStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum TransactionSource {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
}

/** @format int32 */
export enum SnappPayStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
}

/** @format int32 */
export enum SmsType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
}

/** @format int32 */
export enum SmsTemplateStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum SmsRequestStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum SmsGroupTemplateType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
}

/** @format int32 */
export enum SmartAudienceKind {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
  Value8 = 8,
  Value9 = 9,
  Value10 = 10,
  Value11 = 11,
  Value12 = 12,
  Value13 = 13,
  Value14 = 14,
  Value15 = 15,
  Value16 = 16,
  Value17 = 17,
  Value18 = 18,
  Value19 = 19,
}

/** @format int32 */
export enum SimCardOperator {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
  Value8 = 8,
}

/** @format int32 */
export enum SettlementStatus {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum ServiceType {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

export enum ReviewVisibilityStatus {
  Unpublished = "unpublished",
  Published = "published",
  Hidden = "hidden",
}

export enum ReviewVisibilityAction {
  Publish = "publish",
  Hide = "hide",
}

export enum ReviewSubjectMode {
  Overall = "overall",
  Items = "items",
}

export enum ReviewSort {
  Newest = "newest",
  Oldest = "oldest",
  HighestRated = "highestRated",
  LowestRated = "lowestRated",
}

export enum ReviewSendState {
  Queued = "queued",
  Scheduled = "scheduled",
  Dispatching = "dispatching",
  Sent = "sent",
  Delivered = "delivered",
  Failed = "failed",
  Unknown = "unknown",
  Cancelled = "cancelled",
}

export enum ReviewSendKind {
  Initial = "initial",
  Resend = "resend",
}

export enum ReviewReplyState {
  None = "none",
  Draft = "draft",
  Published = "published",
}

export enum ReviewReplyAction {
  SaveDraft = "saveDraft",
  Publish = "publish",
}

export enum ReviewRejectReason {
  PersonalData = "personalData",
  Abuse = "abuse",
  SpamOrUnrelated = "spamOrUnrelated",
  Other = "other",
}

export enum ReviewRatingTarget {
  Visit = "visit",
  Professional = "professional",
}

export enum ReviewModerationStatus {
  Pending = "pending",
  Approved = "approved",
  Rejected = "rejected",
}

export enum ReviewModerationDecision {
  Approved = "approved",
  Rejected = "rejected",
}

export enum ReviewInvitationState {
  Active = "active",
  Submitted = "submitted",
  Expired = "expired",
  Revoked = "revoked",
}

export enum ReviewEligibility {
  Eligible = "eligible",
  Blocked = "blocked",
  Revoked = "revoked",
}

export enum ReviewConsentState {
  NotGranted = "notGranted",
  Granted = "granted",
  Withdrawn = "withdrawn",
}

export enum ReviewBillingStatus {
  NotCharged = "notCharged",
  Charged = "charged",
  Compensated = "compensated",
}

export enum ReviewAttributionValidity {
  Valid = "valid",
  NeedsReview = "needsReview",
  Invalid = "invalid",
}

/** @format int32 */
export enum ReviewActorType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum PurchasePaymentStatus {
  Value0 = 0,
  Value1 = 1,
  Value3 = 3,
}

/** @format int32 */
export enum PurchasePaymentMethod {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum PaymentType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum OtpCodeType {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
}

/** @format int32 */
export enum MerchantUserType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum MerchantUserStatus {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum MerchantServicePriceType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum MerchantCustomerNotifierType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum MarkupType {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum Gender {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum FeeValueType {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum FeePayer {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum DiscountType {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum DayOfWeek {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
}

/** @format int32 */
export enum BusinessType {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
}

/** @format int32 */
export enum BankGateway {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
}

/** @format int32 */
export enum AppType {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum AppointmentStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
}

/** @format int32 */
export enum AdminTransactionStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
}

/** @format int32 */
export enum AdminTransactionSource {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
}

/** @format int32 */
export enum AdminTransactionDirection {
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum Actor {
  Value1 = 1,
  Value10 = 10,
  Value20 = 20,
  Value21 = 21,
}

export interface AcceptMerchantVerificationCommand {
  /** @format int32 */
  merchantId?: number;
}

export interface AcceptSendSmsRegionRequestCommand {
  /** @format int64 */
  id?: number;
}

export interface AcceptSmsTemplateCommand {
  /** @format int32 */
  id?: number;
}

export interface AddContactUsCommand {
  subject?: string | null;
  phoneNumber?: string | null;
  email?: string | null;
  message?: string | null;
  captchaToken?: string | null;
}

export interface AddCustomerGroupMemberCommand {
  /** @format int32 */
  customerGroupId?: number;
  /** @format int64 */
  customerId?: number;
}

export interface AddCustomerOwnerCommand {
  /** @format int64 */
  customerId?: number;
}

export interface AddCustomersGroupMemberCommand {
  /** @format int32 */
  customerGroupId?: number;
  customerIds?: number[] | null;
}

export interface AddMerchantUserPortfolioImageCommandResponse {
  /** @format date-time */
  responseTime?: string;
  /** @format int32 */
  id?: number;
  image?: FileRecord;
  /** @format int32 */
  order?: number;
}

export interface AddWorkScheduleCommand {
  fromDate?: DateOnly;
  toDate?: DateOnly;
  /** @format int32 */
  merchantUserId?: number | null;
  weekDays?: AddWorkScheduleCommandItem[] | null;
}

export interface AddWorkScheduleCommandItem {
  weekDay?: WeekDay;
  timeSlots?: AddWorkScheduleCommandTimeSlotItem[] | null;
}

export interface AddWorkScheduleCommandTimeSlotItem {
  startTime?: TimeOnly;
  endTime?: TimeOnly;
}

export interface AdminCustomerPurchaseDto {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  creationTime?: string;
  /** @format int32 */
  merchantId?: number;
  merchantTitle?: string | null;
  merchantPhoneNumber?: string | null;
  /** @format int64 */
  customerId?: number;
  customer?: SimpleCustomerDto;
  description?: string | null;
  /** @format double */
  totalAmount?: number;
  /** @format double */
  deposit?: number;
  /** @format double */
  payableAmount?: number;
  /** @format double */
  discountAmount?: number;
  discountCode?: string | null;
  /** @format double */
  appointmentDiscountAmount?: number;
  /** @format double */
  directAmount?: number;
  /** @format double */
  creditAmount?: number;
  paymentMethod?: PurchasePaymentMethod;
  paymentStatus?: PurchasePaymentStatus;
  /** @format date-time */
  paymentStatusChangeTime?: string | null;
  transactionId?: string | null;
  /** @format int32 */
  retriedFromPurchaseId?: number | null;
  /** @format int32 */
  itemsCount?: number;
}

export interface AdminCustomerPurchaseDtoPageFilterResponse {
  /** @format int32 */
  count?: number;
  result?: AdminCustomerPurchaseDto[] | null;
}

export interface AdminSmsTemplateDto {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  creationTime?: string;
  /** @format int32 */
  merchantId?: number;
  merchantMobileNumber?: string | null;
  merchantFullName?: string | null;
  merchantTypeTitle?: string | null;
  title?: string | null;
  text?: string | null;
  status?: SmsTemplateStatus;
  adminMessage?: string | null;
  applicableSmsTypes?: SmsType[] | null;
}

export interface AdminSmsTemplateDtoPageFilterResponse {
  /** @format int32 */
  count?: number;
  result?: AdminSmsTemplateDto[] | null;
}

export interface AdminTransactionDetailDto {
  cardNumber?: string | null;
  cardHash?: string | null;
  /** @format double */
  gatewayFee?: number | null;
  /** @format double */
  creditAmount?: number | null;
  /** @format double */
  externalSourceAmount?: number | null;
  isTokenIssued?: boolean | null;
  /** @format int64 */
  appointmentQueueId?: number | null;
  /** @format int32 */
  customerPurchaseId?: number | null;
  walletTransactionSource?: TransactionSource;
  /** @format int32 */
  merchantUserId?: number | null;
  merchantUserFullName?: string | null;
  /** @format int32 */
  itemCount?: number | null;
  /** @format double */
  grossAmount?: number | null;
  /** @format double */
  commissionAmount?: number | null;
  /** @format date-time */
  periodFrom?: string | null;
  /** @format date-time */
  periodTo?: string | null;
}

export interface AdminTransactionDto {
  source?: AdminTransactionSource;
  /** @format int64 */
  sourceId?: number;
  /** @format date-time */
  transactionDate?: string;
  /** @format date-time */
  creationTime?: string;
  /** @format int32 */
  merchantId?: number | null;
  merchantTitle?: string | null;
  merchantPhoneNumber?: string | null;
  /** @format int64 */
  customerId?: number | null;
  customer?: SimpleCustomerDto;
  mobile?: string | null;
  /** @format double */
  amount?: number;
  direction?: AdminTransactionDirection;
  status?: AdminTransactionStatus;
  nativeStatus?: string | null;
  /** @format date-time */
  statusChangeTime?: string | null;
  bankGateway?: BankGateway;
  referenceNumber?: string | null;
  description?: string | null;
  detail?: AdminTransactionDetailDto;
}

export interface AdminTransactionGatewayTotalDto {
  bankGateway?: BankGateway;
  /** @format int32 */
  count?: number;
  /** @format int32 */
  successfulCount?: number;
  /** @format double */
  successfulAmount?: number;
}

export interface AdminTransactionReportDto {
  /** @format int32 */
  count?: number;
  result?: AdminTransactionDto[] | null;
  summary?: AdminTransactionSummaryDto;
}

export interface AdminTransactionSourceTotalDto {
  source?: AdminTransactionSource;
  direction?: AdminTransactionDirection;
  /** @format int32 */
  count?: number;
  /** @format int32 */
  successfulCount?: number;
  /** @format double */
  successfulAmount?: number;
}

export interface AdminTransactionStatusCountDto {
  status?: AdminTransactionStatus;
  /** @format int32 */
  count?: number;
}

export interface AdminTransactionSummaryDto {
  /** @format int32 */
  totalCount?: number;
  /** @format double */
  totalIn?: number;
  /** @format double */
  totalOut?: number;
  bySource?: AdminTransactionSourceTotalDto[] | null;
  byGateway?: AdminTransactionGatewayTotalDto[] | null;
  byStatus?: AdminTransactionStatusCountDto[] | null;
}

export interface AppointmentCalendarB2CDto {
  appointmentDate?: DateOnly;
  appointments?: AppointmentDetailB2CDto[] | null;
}

export interface AppointmentCalendarDto {
  appointmentDate?: DateOnly;
  appointments?: AppointmentDetailDto[] | null;
}

export interface AppointmentCancellationDto {
  description?: string | null;
  /** @format date-time */
  cancelDate?: string;
}

export interface AppointmentDetailB2CDto {
  /** @format int64 */
  id?: number;
  status?: AppointmentStatus;
  startTime?: TimeOnly;
  endTime?: TimeOnly;
  actor?: Actor;
}

export interface AppointmentDetailDto {
  /** @format int64 */
  id?: number;
  merchant?: SimpleMerchantDto;
  /** @format int32 */
  merchantServiceId?: number;
  merchantServiceTitle?: string | null;
  merchantServiceColor?: string | null;
  /** @format int32 */
  merchantUserId?: number;
  merchantUserFirstName?: string | null;
  merchantUserLastName?: string | null;
  /** @format int64 */
  customerId?: number;
  customerFirstName?: string | null;
  customerLastName?: string | null;
  customerMobileNumber?: string | null;
  description?: string | null;
  status?: AppointmentStatus;
  /** @format date-time */
  appointmentDate?: string;
  startTime?: TimeOnly;
  endTime?: TimeOnly;
  actor?: Actor;
  purchaseRegistered?: boolean;
  isDepositPayment?: boolean;
  rateBreakdown?: AppointmentDetailRateBreakdownDto;
  cancellation?: AppointmentCancellationDto;
}

export interface AppointmentDetailRateBreakdownDto {
  /** @format double */
  price?: number;
  /** @format double */
  markupAmount?: number;
  /** @format double */
  totalPrice?: number;
  /** @format double */
  servicePrice?: number;
}

export interface AppointmentQueueDto {
  /** @format int64 */
  id?: number;
  /** @format int32 */
  merchantId?: number;
  merchantInfo?: string | null;
  subDomain?: string | null;
  customerMobileNumber?: string | null;
  customerFirstName?: string | null;
  customerLastName?: string | null;
  actor?: Actor;
  status?: AppointmentStatus;
  /** @format date-time */
  creationTime?: string;
  /** @format double */
  totalPrice?: number;
  /** @format double */
  customerFeeAmount?: number;
  /** @format double */
  discountAmount?: number;
  discountCode?: string | null;
  rrn?: string | null;
  cardNumber?: string | null;
  bankGateway?: BankGateway;
  snappPayNeedsInquiry?: boolean;
  isDepositPayment?: boolean;
  appointments?: AppointmentQueueItemDto[] | null;
}

export interface AppointmentQueueItemDto {
  /** @format int64 */
  appointmentId?: number;
  /** @format date-time */
  appointmentDate?: string;
  /** @format int32 */
  merchantServiceId?: number;
  merchantServiceTitle?: string | null;
  merchantServiceColor?: string | null;
  /** @format int32 */
  merchantUserId?: number;
  merchantUserFirstName?: string | null;
  merchantUserLastName?: string | null;
  description?: string | null;
  status?: AppointmentStatus;
  startTime?: TimeOnly;
  endTime?: TimeOnly;
  /** @format double */
  totalPrice?: number;
  purchaseRegistered?: boolean;
  isDepositPayment?: boolean;
}

export interface AppointmentSnappPayEligibilityCommand {
  /** @format int64 */
  appointmentQueueId?: number | null;
  /** @format double */
  amount?: number | null;
  /** @format int32 */
  merchantId?: number | null;
}

export interface AppointmentSnappPayEligibilityResponse {
  /** @format date-time */
  responseTime?: string;
  eligible?: boolean;
  /** @format double */
  amount?: number;
  title?: string | null;
  description?: string | null;
}

export interface AppointmentSnappPayInquiryResponse {
  /** @format date-time */
  responseTime?: string;
  isSuccess?: boolean;
  status?: SnappPayStatus;
  message?: string | null;
}

export interface AssignCustomerOwnersCommand {
  customerIds?: number[] | null;
  merchantUserIds?: number[] | null;
}

export interface AssignCustomerOwnersCommandResponse {
  /** @format date-time */
  responseTime?: string;
  /** @format int32 */
  assignedCount?: number;
  /** @format int32 */
  alreadyAssignedCount?: number;
  /** @format int32 */
  customerCount?: number;
  /** @format int32 */
  merchantUserCount?: number;
}

export interface B2CPlaceAppointmentCommandItem {
  date?: DateOnly;
  startTime?: TimeOnly;
  /** @format int32 */
  merchantServiceId?: number;
  /** @format int32 */
  merchantUserId?: number;
}

export interface B2CPlaceAppointmentQueueCommand {
  /** @format int64 */
  appointmentQueueId?: number;
  bankGateway?: BankGateway;
}

export interface B2CPlaceAppointmentsCommand {
  /** @format int32 */
  merchantId?: number;
  description?: string | null;
  discountCode?: string | null;
  services?: B2CPlaceAppointmentCommandItem[] | null;
  bankGateway?: BankGateway;
}

export interface BarberCustomerBirthdayDto {
  /** @format int64 */
  customerId?: number;
  fullName?: string | null;
  phoneNumber?: string | null;
  /** @format date-time */
  birthDate?: string;
  /** @format int32 */
  daysUntil?: number;
}

export interface BarberCustomerBreakdownDto {
  /** @format int32 */
  total?: number;
  new?: DashboardCountMetricDto;
  returning?: DashboardCountMetricDto;
  /** @format int32 */
  inactive?: number;
  /** @format double */
  retentionPercent?: number | null;
}

export interface BarberDashboardOverviewDto {
  period?: DashboardPeriodDto;
  barber?: BarberIdentityDto;
  headline?: BarberHeadlineDto;
  earnings?: BarberEarningsDto;
  earningsTrend?: BarberEarningsTrendPointDto[] | null;
  schedule?: BarberScheduleDto;
  appointmentBreakdown?: DashboardAppointmentBreakdownDto;
  customers?: BarberCustomerBreakdownDto;
  followUps?: BarberFollowUpsDto;
  topServices?: BarberTopServiceDto[] | null;
  quality?: BarberQualityDto;
}

export interface BarberEarningsDto {
  registeredWork?: DashboardMoneyMetricDto;
  /** @format double */
  settleableEarnings?: number;
  /** @format double */
  grossGenerated?: number;
  /** @format double */
  salonCommission?: number;
  /** @format double */
  outstanding?: number;
  /** @format double */
  settledInPeriod?: number;
  lastSettlement?: BarberLastSettlementDto;
  /** @format double */
  averagePerVisit?: number | null;
}

export interface BarberEarningsTrendPointDto {
  /** @format date-time */
  date?: string;
  /** @format double */
  total?: number;
  /** @format double */
  paid?: number;
  /** @format double */
  pending?: number;
}

export interface BarberFollowUpsDto {
  lapsedCustomers?: DashboardLapsedCustomersDto;
  upcomingBirthdays?: BarberCustomerBirthdayDto[] | null;
  /** @format int32 */
  unpaidBookingCount?: number;
}

export interface BarberHeadlineDto {
  todayEarnings?: DashboardMoneyMetricDto;
  monthEarnings?: DashboardMoneyMetricDto;
  todayAppointments?: DashboardTodayAppointmentsDto;
  nextAppointment?: BarberNextAppointmentDto;
  capacity?: DashboardCapacityDto;
  rank?: BarberRankDto;
}

export interface BarberHourLoadDto {
  /** @format int32 */
  hour?: number;
  /** @format int32 */
  visitCount?: number;
}

export interface BarberIdentityDto {
  /** @format int32 */
  merchantUserId?: number;
  fullName?: string | null;
  jobTitle?: string | null;
  image?: FileRecord;
  merchantUserType?: MerchantUserType;
  /** @format int32 */
  commissionPercentage?: number;
  isSelf?: boolean;
}

export interface BarberLastSettlementDto {
  /** @format int32 */
  settlementId?: number;
  /** @format date-time */
  settleDate?: string;
  /** @format double */
  amount?: number;
  /** @format int32 */
  itemCount?: number;
}

export interface BarberNextAppointmentDto {
  /** @format int64 */
  appointmentId?: number;
  /** @format date-time */
  appointmentDate?: string;
  startTime?: TimeOnly;
  endTime?: TimeOnly;
  /** @format int32 */
  durationMinutes?: number;
  customerFullName?: string | null;
  customerPhoneNumber?: string | null;
  serviceTitle?: string | null;
  /** @format int32 */
  minutesFromNow?: number;
}

export interface BarberQualityDto {
  /** @format double */
  noShowPercent?: number | null;
  /** @format double */
  cancelPercent?: number | null;
  visits?: DashboardCountMetricDto;
  /** @format int32 */
  bookedServiceCount?: number;
  /** @format int32 */
  walkInServiceCount?: number;
  /** @format double */
  averageServiceMinutes?: number | null;
}

export interface BarberRankDto {
  /** @format int32 */
  position?: number;
  /** @format int32 */
  teamSize?: number;
  hasData?: boolean;
}

export interface BarberScheduleDto {
  tomorrowFreeCapacity?: DashboardTomorrowCapacityDto;
  upcomingAppointments?: BarberNextAppointmentDto[] | null;
  weekdayLoad?: BarberWeekdayLoadDto[] | null;
  hourLoad?: BarberHourLoadDto[] | null;
}

export interface BarberTopServiceDto {
  /** @format int32 */
  merchantServiceId?: number;
  title?: string | null;
  /** @format int32 */
  count?: number;
  /** @format double */
  earnings?: number;
}

export interface BarberWeekdayLoadDto {
  dayOfWeek?: DayOfWeek;
  /** @format int32 */
  visitCount?: number;
  /** @format int32 */
  bookedMinutes?: number;
}

export interface CalculateCustomerGroupDiscountSmsAmountCommand {
  /** @format int32 */
  smsTemplateId?: number;
  /** @format date-time */
  expireDate?: string;
  expireTime?: TimeSpan;
  /** @format double */
  amount?: number;
  /** @format int32 */
  percent?: number;
  /** @format double */
  maximumAmount?: number | null;
  /** @format double */
  minimumAmount?: number | null;
  /** @format int32 */
  customerGroupId?: number;
  discountCode?: string | null;
}

export interface CalculatedSmsRegionRequestDto {
  /** @format double */
  amount?: number;
  /** @format int32 */
  allMobileNumbersCount?: number;
  /** @format int32 */
  mobileNumbersCount?: number;
  /** @format int32 */
  smsCount?: number;
}

export interface CalculateGroupDiscountSmsAmountCommand {
  /** @format int32 */
  smsTemplateId?: number;
  /** @format date-time */
  expireDate?: string;
  expireTime?: TimeSpan;
  /** @format double */
  amount?: number;
  /** @format int32 */
  percent?: number;
  /** @format double */
  maximumAmount?: number | null;
  /** @format double */
  minimumAmount?: number | null;
  /** @format int32 */
  discountGroupId?: number;
  discountCode?: string | null;
}

export interface CalculateRegionSmsAmountCommand {
  /** @format int32 */
  smsTemplateId?: number;
  regionPostalCode?: string | null;
  gender?: Gender;
  simCardOperator?: SimCardOperator;
  /** @format int32 */
  sendCount?: number | null;
}

export interface CalculateSmartAudienceAmountCommand {
  /** @format int32 */
  smsTemplateId?: number;
  audienceKey?: string | null;
  /** @format int32 */
  merchantUserId?: number | null;
  excludeCustomerIds?: number[] | null;
}

export interface CalculateSmsAmountCommand {
  /** @format int32 */
  smsTemplateId?: number;
  customerIds?: number[] | null;
}

export interface CalculateSmsGroupAmountCommand {
  /** @format int32 */
  smsTemplateId?: number;
  /** @format int32 */
  groupId?: number;
}

export interface CalculateSmsSpecialGroupAmountCommand {
  /** @format int32 */
  smsTemplateId?: number;
  /** @format int32 */
  specialGroupId?: number;
}

export interface CancelAppointmentCommand {
  /** @format int64 */
  appointmentId?: number;
  cancellationDescription?: string | null;
}

export interface CancelAppointmentCommandResponse {
  /** @format date-time */
  responseTime?: string;
}

export interface CancelAppointmentQueueCommand {
  /** @format int64 */
  appointmentQueueId?: number;
  cancellationDescription?: string | null;
}

export interface CancelAppointmentQueueCommandResponse {
  status?: AppointmentStatus;
}

export interface CancelMerchantUserSettlementCommand {
  reason?: string | null;
}

export interface CancelSnappPayPaymentCommand {
  transactionId?: string | null;
}

export interface ChangeReviewVisibilityCommand {
  action?: ReviewVisibilityAction;
  reason?: string | null;
  expectedVersion?: string | null;
}

export interface CheckCustomerNotifierDto {
  message?: string | null;
  isEnoughBalance?: boolean;
}

export interface CheckUserCommand {
  username?: string | null;
}

export interface CommandResponse {
  /** @format date-time */
  responseTime?: string;
}

export interface ConfirmPurchaseCreditPaymentResponse {
  /** @format date-time */
  responseTime?: string;
  paymentPageUrl?: string | null;
}

export interface CreateAppInfoCommand {
  imei?: string | null;
  pushToken?: string | null;
}

export interface CreateCustomerCommand {
  phoneNumber?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  /** @format date-time */
  birthDate?: string | null;
  /** @format date-time */
  dateOfMarriage?: string | null;
  gender?: Gender;
  referrer?: string | null;
}

export interface CreateCustomerCommandResponse {
  /** @format date-time */
  responseTime?: string;
  /** @format int64 */
  customerId?: number;
}

export interface CreateCustomerGroupCommand {
  name?: string | null;
  description?: string | null;
}

export interface CreateCustomerGroupDiscountCommand {
  /** @format date-time */
  expireDate?: string;
  expireTime?: TimeSpan;
  discountType?: DiscountType;
  /** @format double */
  amount?: number;
  /** @format int32 */
  percent?: number;
  /** @format double */
  maximumAmount?: number | null;
  /** @format double */
  minimumAmount?: number | null;
  /** @format int32 */
  count?: number;
  /** @format int32 */
  smsTemplateId?: number;
  /** @format int32 */
  customerGroupId?: number;
  discountCode?: string | null;
}

export interface CreateCustomerItemCommand {
  phoneNumber?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

export interface CreateCustomerPurchaseCommand {
  /** @format int64 */
  customerId?: number;
  description?: string | null;
  items?: CreateCustomerPurchaseCommandItem[] | null;
  /** @format double */
  directAmount?: number | null;
  /** @format double */
  creditAmount?: number | null;
  discountCode?: string | null;
  reviewInvitation?: CreateReviewInvitationRequest;
}

export interface CreateCustomerPurchaseCommandItem {
  /** @format int32 */
  merchantUserId?: number | null;
  /** @format int32 */
  merchantServiceId?: number | null;
  /** @format double */
  amount?: number;
  /** @format int32 */
  markupPercentage?: number;
  /** @format int64 */
  appointmentId?: number | null;
  /** @format int64 */
  appointmentQueueId?: number | null;
  isWalkIn?: boolean;
  walkInPaymentMethod?: WalkInPaymentMethod;
}

export interface CreateCustomerPurchaseCommandResponse {
  /** @format date-time */
  responseTime?: string;
  /** @format int32 */
  purchaseId?: number;
  paymentStatus?: PurchasePaymentStatus;
  transactionId?: string | null;
  paymentLinkUrl?: string | null;
  reviewInvitation?: ReviewInvitationResult;
  paymentLinkFailureMessage?: string | null;
}

export interface CreateCustomersCommand {
  items?: CreateCustomerItemCommand[] | null;
}

export interface CreateCustomersCommandResponse {
  /** @format date-time */
  responseTime?: string;
  /** @format int32 */
  registeredCount?: number;
  /** @format int32 */
  existCount?: number;
}

export interface CreateDiscountGroupCommand {
  /** @format date-time */
  expireDate?: string;
  expireTime?: TimeSpan;
  discountType?: DiscountType;
  /** @format double */
  amount?: number;
  /** @format int32 */
  percent?: number;
  /** @format double */
  maximumAmount?: number | null;
  /** @format double */
  minimumAmount?: number | null;
  /** @format int32 */
  count?: number;
  /** @format int32 */
  smsTemplateId?: number;
  /** @format int32 */
  discountGroupId?: number;
  discountCode?: string | null;
}

export interface CreateMerchantServiceCategoryCommand {
  title?: string | null;
  description?: string | null;
}

export interface CreateMerchantServiceCommand {
  /** @format int32 */
  serviceCategoryId?: number;
  title?: string | null;
  description?: string | null;
  color?: string | null;
  /** @format int32 */
  durationPartInMinute?: number;
  priceType?: MerchantServicePriceType;
  /** @format double */
  startingPrice?: number | null;
}

export interface CreateMerchantSmsTemplateCommand {
  title?: string | null;
  text?: string | null;
}

export interface CreateMerchantUserSettlementCommand {
  /** @format int32 */
  merchantUserId?: number;
  /** @format date-time */
  fromDate?: string;
  /** @format date-time */
  toDate?: string;
  customerPurchaseItemIds?: number[] | null;
  /** @format date-time */
  settleDate?: string;
  rrn?: string | null;
  description?: string | null;
}

export interface CreateMerchantUserSettlementCommandResponse {
  /** @format date-time */
  responseTime?: string;
  /** @format int32 */
  settlementId?: number;
  /** @format int32 */
  merchantUserId?: number;
  /** @format int32 */
  itemCount?: number;
  /** @format double */
  grossAmount?: number;
  /** @format double */
  commissionAmount?: number;
  /** @format double */
  totalAmount?: number;
  /** @format date-time */
  settleDate?: string;
}

export interface CreateReviewInvitationRequest {
  requested?: boolean;
  servicesPerformedConfirmed?: boolean;
  templateVersion?: string | null;
}

export interface CreateTransactionCreditCommand {
  /** @format double */
  amount?: number;
  bankGateway?: BankGateway;
  /** @format uuid */
  sourceId?: string;
}

export interface CustomerDto {
  /** @format int64 */
  id?: number;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  /** @format date-time */
  creationTime?: string;
  /** @format date-time */
  birthDate?: string | null;
  /** @format date-time */
  dateOfMarriage?: string | null;
  gender?: Gender;
  actor?: Actor;
  referrer?: string | null;
}

export interface CustomerDtoPageFilterResponse {
  /** @format int32 */
  count?: number;
  result?: CustomerDto[] | null;
}

export interface CustomerGroupDto {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  creationTime?: string;
  name?: string | null;
  description?: string | null;
  /** @format int32 */
  membersCount?: number;
}

export interface CustomerGroupDtoPageFilterResponse {
  /** @format int32 */
  count?: number;
  result?: CustomerGroupDto[] | null;
}

export interface CustomerInfoDto {
  /** @format int64 */
  id?: number;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  /** @format date-time */
  creationTime?: string;
  gender?: Gender;
  actor?: Actor;
  /** @format int32 */
  purchaseCount?: number;
  /** @format double */
  sumPurchaseAmount?: number;
  /** @format date-time */
  birthDate?: string | null;
  referrer?: string | null;
}

export interface CustomerInvitationDto {
  merchant?: ReviewMerchantPublicInfoDto;
  state?: ReviewInvitationState;
  /** @format date-time */
  expiresAtUtc?: string;
  /** @format date-time */
  invoiceDateUtc?: string;
  serviceDatesUtc?: string[] | null;
  items?: ReviewInvitationItemDto[] | null;
  rateableProfessionals?: RateableProfessionalDto[] | null;
  limits?: ReviewFormLimitsDto;
  requiredConsentPolicyVersion?: string | null;
  existingReview?: CustomerReviewDto;
  allowedActions?: string[] | null;
}

export interface CustomerProfessionalRatingDto {
  /** @format int32 */
  merchantUserId?: number;
  displayName?: string | null;
  /** @format int32 */
  rating?: number;
}

export interface CustomerPurchaseCreditAttemptDto {
  transactionId?: string | null;
  /** @format double */
  amount?: number;
  /** @format double */
  externalSourceAmount?: number;
  /** @format double */
  totalAmount?: number;
  status?: SnappPayStatus;
  /** @format date-time */
  changeStatusTime?: string | null;
  /** @format date-time */
  creationTime?: string;
  isTokenIssued?: boolean;
}

export interface CustomerPurchaseDepositDto {
  /** @format int64 */
  appointmentQueueId?: number;
  bankGateway?: BankGateway;
  /** @format double */
  amount?: number;
  /** @format double */
  invoicedAmount?: number;
  /** @format double */
  remainingAmount?: number;
  /** @format date-time */
  paymentDate?: string | null;
  rrn?: string | null;
  isDepositPayment?: boolean;
}

export interface CustomerPurchaseDetailDto {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  creationTime?: string;
  description?: string | null;
  /** @format double */
  deposit?: number;
  customer?: SimpleCustomerDto;
  /** @format int64 */
  customerId?: number;
  /** @format int32 */
  merchantId?: number;
  merchantTitle?: string | null;
  /** @format double */
  totalAmount?: number;
  /** @format double */
  discountAmount?: number;
  discountCode?: string | null;
  /** @format double */
  appointmentDiscountAmount?: number;
  /** @format double */
  directAmount?: number;
  /** @format double */
  creditAmount?: number;
  /** @format double */
  commissionAmount?: number;
  /** @format double */
  barberAmount?: number;
  paymentMethod?: PurchasePaymentMethod;
  paymentStatus?: PurchasePaymentStatus;
  /** @format date-time */
  paymentStatusChangeTime?: string | null;
  transactionId?: string | null;
  /** @format int32 */
  retriedFromPurchaseId?: number | null;
  deposits?: CustomerPurchaseDepositDto[] | null;
  depositTotalsByGateway?: CustomerPurchaseGatewayTotalDto[] | null;
  items?: CustomerPurchaseItemDetailDto[] | null;
  creditAttempts?: CustomerPurchaseCreditAttemptDto[] | null;
}

export interface CustomerPurchaseDto {
  /** @format int32 */
  id?: number;
  customer?: SimpleCustomerDto;
  /** @format double */
  deposit?: number;
  /** @format double */
  discountAmount?: number;
  discountCode?: string | null;
  /** @format double */
  appointmentDiscountAmount?: number;
  description?: string | null;
  rateBreakdown?: CustomerPurchaseRateBreakdownDto;
  paymentMethod?: PurchasePaymentMethod;
  paymentStatus?: PurchasePaymentStatus;
  /** @format double */
  directAmount?: number;
  /** @format double */
  creditAmount?: number;
  transactionId?: string | null;
  deposits?: CustomerPurchaseDepositDto[] | null;
}

export interface CustomerPurchaseGatewayTotalDto {
  bankGateway?: BankGateway;
  /** @format double */
  amount?: number;
  /** @format int32 */
  bookingCount?: number;
}

export interface CustomerPurchaseItemDetailDto {
  /** @format int32 */
  id?: number;
  purchaseType?: string | null;
  walkInPaymentMethod?: WalkInPaymentMethod;
  /** @format int32 */
  merchantServiceId?: number;
  serviceTitle?: string | null;
  /** @format int32 */
  merchantUserId?: number;
  merchantUserFullName?: string | null;
  /** @format double */
  grossAmount?: number;
  /** @format float */
  commissionPercentage?: number;
  /** @format double */
  commissionAmount?: number;
  /** @format double */
  barberAmount?: number;
  /** @format int64 */
  appointmentId?: number | null;
  /** @format int64 */
  appointmentQueueId?: number | null;
  isSettled?: boolean;
  /** @format int32 */
  settlementId?: number | null;
  /** @format date-time */
  settleDate?: string | null;
}

export interface CustomerPurchaseRateBreakdownDto {
  /** @format double */
  amount?: number;
  /** @format float */
  markupPercentage?: number;
  /** @format double */
  amountWithoutMarkup?: number;
}

export interface CustomerRefreshTokenCommand {
  /** @format uuid */
  refreshTokenId?: string;
}

export interface CustomerResetPasswordCommand {
  username?: string | null;
  /** @format uuid */
  securityToken?: string;
  newPassword?: string | null;
}

export interface CustomerReviewDto {
  /** @format uuid */
  reviewPublicId?: string;
  merchant?: ReviewMerchantPublicInfoDto;
  /** @format int32 */
  visitRating?: number;
  text?: string | null;
  subjectMode?: ReviewSubjectMode;
  subjectItemIds?: number[] | null;
  professionalRatings?: CustomerProfessionalRatingDto[] | null;
  displayName?: string | null;
  publicConsent?: ReviewConsentState;
  contextConsent?: ReviewConsentState;
  moderationStatus?: ReviewModerationStatus;
  visibilityStatus?: ReviewVisibilityStatus;
  publishedReply?: string | null;
  /** @format date-time */
  submittedAtUtc?: string;
  allowedActions?: string[] | null;
  version?: string | null;
}

export interface CustomersDiscountCommand {
  /** @format date-time */
  expireDate?: string;
  expireTime?: TimeSpan;
  discountType?: DiscountType;
  /** @format double */
  amount?: number;
  /** @format int32 */
  percent?: number;
  /** @format double */
  maximumAmount?: number | null;
  /** @format double */
  minimumAmount?: number | null;
  /** @format int32 */
  count?: number;
  /** @format int32 */
  smsTemplateId?: number;
  allCustomers?: boolean;
  customerIds?: number[] | null;
  discountCode?: string | null;
}

export interface CustomerSendOtpCodeCommand {
  username?: string | null;
}

export interface CustomerSignInCommand {
  username?: string | null;
  password?: string | null;
}

export interface CustomerSignUpCommand {
  mobileNumber?: string | null;
}

export interface CustomerVerifyForgetPasswordOtpCommand {
  username?: string | null;
  otpCode?: string | null;
}

export interface CustomerVerifyOtpCommand {
  username?: string | null;
  otpCode?: string | null;
}

export interface CustomerVerifySignUpCommand {
  firstName?: string | null;
  lastName?: string | null;
  mobileNumber?: string | null;
  email?: string | null;
  otpCode?: string | null;
  imei?: string | null;
}

export interface DashboardAppointmentBreakdownDto {
  /** @format int32 */
  total?: number;
  /** @format int32 */
  completed?: number;
  /** @format int32 */
  upcoming?: number;
  /** @format int32 */
  canceled?: number;
  /** @format int32 */
  noShow?: number;
  /** @format int32 */
  failed?: number;
}

export interface DashboardAppointmentsDto {
  /** @format int32 */
  onlineBooked?: number;
  /** @format int32 */
  staffBooked?: number;
  /** @format int32 */
  today?: number;
  /** @format int32 */
  booked?: number;
  /** @format int32 */
  confirmed?: number;
  /** @format int32 */
  canceled?: number;
  /** @format double */
  depositsCollected?: number;
  /** @format double */
  forfeitedDeposits?: number;
}

export interface DashboardBarberDto {
  /** @format int32 */
  merchantUserId?: number;
  fullName?: string | null;
  /** @format int32 */
  serviceCount?: number;
  /** @format double */
  grossGenerated?: number;
  /** @format double */
  earned?: number;
  /** @format double */
  salonKept?: number;
  /** @format double */
  settled?: number;
  /** @format double */
  outstanding?: number;
}

export interface DashboardBookingBucketDto {
  /** @format int32 */
  count?: number;
  /** @format double */
  amount?: number;
}

export interface DashboardCapacityDto {
  /** @format double */
  fillRatePercent?: number;
  /** @format double */
  freeRatePercent?: number;
  /** @format int32 */
  bookedMinutes?: number;
  /** @format int32 */
  availableMinutes?: number;
  hasSchedule?: boolean;
}

export interface DashboardCountMetricDto {
  /** @format int32 */
  value?: number;
  /** @format int32 */
  previousValue?: number;
  /** @format double */
  changePercent?: number | null;
}

export interface DashboardCustomerBreakdownDto {
  /** @format int32 */
  total?: number;
  /** @format int32 */
  new?: number;
  /** @format int32 */
  returning?: number;
  /** @format int32 */
  inactive?: number;
}

export interface DashboardCustomersDto {
  /** @format int32 */
  registeredInPeriod?: number;
}

export interface DashboardDailySalesDto {
  /** @format date-time */
  date?: string;
  /** @format double */
  paid?: number;
  /** @format double */
  pending?: number;
}

export interface DashboardHeadlineDto {
  todaySales?: DashboardMoneyMetricDto;
  monthSales?: DashboardMoneyMetricDto;
  todayAppointments?: DashboardTodayAppointmentsDto;
  newCustomers?: DashboardCountMetricDto;
  returningCustomers?: DashboardReturningCustomersDto;
  capacity?: DashboardCapacityDto;
}

export interface DashboardLapsedCustomersDto {
  /** @format int32 */
  days?: number;
  /** @format int32 */
  count?: number;
}

export interface DashboardMoneyMetricDto {
  /** @format double */
  value?: number;
  /** @format double */
  paid?: number;
  /** @format double */
  pending?: number;
  /** @format double */
  previousValue?: number;
  /** @format double */
  changePercent?: number | null;
  /** @format date-time */
  from?: string;
  /** @format date-time */
  to?: string;
}

export interface DashboardOpportunitiesDto {
  unpaidBookings?: DashboardUnpaidBookingsDto;
  tomorrowFreeCapacity?: DashboardTomorrowCapacityDto;
  lapsedCustomers?: DashboardLapsedCustomersDto;
}

export interface DashboardPaymentMixDto {
  /** @format double */
  direct?: number;
  /** @format double */
  credit?: number;
}

export interface DashboardPaymentSummaryDto {
  /** @format double */
  depositsCollected?: number;
  paidBookings?: DashboardBookingBucketDto;
  unpaidBookings?: DashboardBookingBucketDto;
  /** @format double */
  totalRegisteredSales?: number;
  /** @format double */
  paidSales?: number;
  /** @format double */
  pendingSales?: number;
}

export interface DashboardPeriodDto {
  /** @format date-time */
  from?: string;
  /** @format date-time */
  to?: string;
  /** @format int32 */
  days?: number;
  /** @format date-time */
  previousFrom?: string;
  /** @format date-time */
  previousTo?: string;
  /** @format int32 */
  inactiveDays?: number;
  /** @format int32 */
  lapsedDays?: number;
}

export interface DashboardProfitDto {
  /** @format double */
  grossMargin?: number;
  /** @format double */
  smsCost?: number;
  /** @format double */
  netProfit?: number;
}

export interface DashboardReturningCustomersDto {
  /** @format int32 */
  value?: number;
  /** @format int32 */
  previousValue?: number;
  /** @format double */
  changePercent?: number | null;
  /** @format double */
  shareOfAllCustomersPercent?: number | null;
}

export interface DashboardSalesDto {
  /** @format double */
  paid?: number;
  /** @format double */
  pending?: number;
  /** @format double */
  failed?: number;
  /** @format int32 */
  paidCount?: number;
  /** @format int32 */
  pendingCount?: number;
  /** @format int32 */
  failedCount?: number;
  /** @format double */
  avgBasket?: number;
}

export interface DashboardSalesTrendPointDto {
  /** @format date-time */
  date?: string;
  /** @format double */
  total?: number;
  /** @format double */
  paid?: number;
  /** @format double */
  pending?: number;
}

export interface DashboardServiceDto {
  /** @format int32 */
  merchantServiceId?: number;
  title?: string | null;
  /** @format int32 */
  count?: number;
  /** @format double */
  gross?: number;
  /** @format double */
  salonKept?: number;
}

export interface DashboardStaffDto {
  /** @format double */
  earnedByBarbers?: number;
  /** @format double */
  settled?: number;
  /** @format double */
  outstanding?: number;
}

export interface DashboardTeamMemberDto {
  /** @format int32 */
  merchantUserId?: number;
  fullName?: string | null;
  jobTitle?: string | null;
  image?: FileRecord;
  /** @format int32 */
  completedAppointments?: number;
  /** @format double */
  sales?: number;
}

export interface DashboardTodayAppointmentsDto {
  /** @format int32 */
  total?: number;
  /** @format int32 */
  completed?: number;
  /** @format int32 */
  remaining?: number;
  /** @format int32 */
  previousTotal?: number;
  /** @format double */
  changePercent?: number | null;
}

export interface DashboardTomorrowCapacityDto {
  /** @format int32 */
  freeMinutes?: number;
  /** @format int32 */
  freeHours?: number;
  /** @format int32 */
  availableMinutes?: number;
  /** @format int32 */
  bookedMinutes?: number;
  hasSchedule?: boolean;
}

export interface DashboardTopServiceDto {
  /** @format int32 */
  merchantServiceId?: number;
  title?: string | null;
  /** @format int32 */
  count?: number;
  /** @format double */
  sales?: number;
}

export interface DashboardUnpaidBookingsDto {
  /** @format int32 */
  customers?: number;
  /** @format int32 */
  bookings?: number;
  /** @format double */
  amount?: number;
}

export interface DateOnly {
  /** @format int32 */
  year?: number;
  /** @format int32 */
  month?: number;
  /** @format int32 */
  day?: number;
  dayOfWeek?: DayOfWeek;
  /** @format int32 */
  dayOfYear?: number;
  /** @format int32 */
  dayNumber?: number;
}

export interface DeleteCustomerCommand {
  /** @format int64 */
  id?: number;
}

export interface DeleteCustomerGroupCommand {
  /** @format int32 */
  id?: number;
}

export interface DeleteMerchantSmsTemplateCommand {
  /** @format int32 */
  id?: number;
}

export interface DiscountDto {
  /** @format int32 */
  count?: number;
  /** @format int32 */
  useCount?: number;
  code?: string | null;
  /** @format date-time */
  expireDate?: string;
  discountType?: DiscountType;
  /** @format double */
  amount?: number;
  /** @format int32 */
  percent?: number;
  /** @format double */
  maximumAmount?: number | null;
  /** @format double */
  minimumAmount?: number | null;
  isValid?: boolean;
}

export interface DiscountGroupDto {
  /** @format int32 */
  id?: number;
  title?: string | null;
  /** @format int32 */
  period?: number;
}

export interface DiscountWithCustomerDto {
  /** @format int32 */
  count?: number;
  /** @format int32 */
  useCount?: number;
  code?: string | null;
  /** @format date-time */
  expireDate?: string;
  discountType?: DiscountType;
  /** @format double */
  amount?: number;
  /** @format int32 */
  percent?: number;
  /** @format double */
  maximumAmount?: number | null;
  /** @format double */
  minimumAmount?: number | null;
  isValid?: boolean;
  customer?: CustomerDto;
}

export interface FailedResponse {
  message?: string | null;
  code?: string | null;
  fieldErrors?: Record<string, string[]> | null;
  traceId?: string | null;
  /** @format date-time */
  retryAfterUtc?: string | null;
  currentVersion?: string | null;
}

export interface FileRecord {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  creationTime?: string;
  fileName?: string | null;
  originalName?: string | null;
  savedPath?: string | null;
}

export interface ITransactionBaseDto {
  /** @format int64 */
  id?: number;
  /** @format double */
  amount?: number;
  /** @format date-time */
  creationTime?: string;
  transactionType?: TransactionType;
  status?: TransactionStatus;
  transactionSource?: string | null;
  description?: string | null;
  rrn?: string | null;
}

export interface ITransactionBaseDtoPageFilterResponse {
  /** @format int32 */
  count?: number;
  result?: ITransactionBaseDto[] | null;
}

export interface ITransactionCreditDto {
  bankGateway?: BankGateway;
  /** @format uuid */
  sourceId?: string | null;
  /** @format int64 */
  id?: number;
  /** @format double */
  amount?: number;
  /** @format date-time */
  creationTime?: string;
  transactionType?: TransactionType;
  status?: TransactionStatus;
  transactionSource?: string | null;
  description?: string | null;
  rrn?: string | null;
}

export interface IWalletBalanceDto {
  /** @format double */
  amount?: number;
}

export interface LocationCommand {
  /** @format double */
  lat?: number;
  /** @format double */
  lon?: number;
}

export interface LocationDto {
  /** @format double */
  lat?: number;
  /** @format double */
  lon?: number;
}

export interface MerchantAppointmentQueueDto {
  /** @format int64 */
  id?: number;
  /** @format date-time */
  creationTime?: string;
  /** @format int32 */
  merchantId?: number;
  merchantInfo?: string | null;
  /** @format int64 */
  customerId?: number;
  customer?: SimpleCustomerDto;
  paymentInfo?: PaymentInfoDto;
  rateBreakdown?: AppointmentDetailRateBreakdownDto;
  appointments?: AppointmentQueueItemDto[] | null;
  status?: AppointmentStatus;
  actor?: Actor;
  /** @format date-time */
  paymentDeadLine?: string;
  hasSettlement?: boolean;
  settlement?: MerchantAppointmentQueueSettlementDto;
  needPayment?: boolean;
  paymentType?: PaymentType;
  isDepositPayment?: boolean;
  /** @format double */
  discountAmount?: number;
  feePayer?: FeePayer;
  /** @format double */
  feeBaseAmount?: number;
  /** @format double */
  customerFeeAmount?: number;
  /** @format double */
  merchantFeeAmount?: number;
  /** @format double */
  payableAmount?: number;
  discountCode?: string | null;
  bankGateway?: BankGateway;
  purchaseRegistered?: boolean;
}

export interface MerchantAppointmentQueueDtoPageFilterResponse {
  /** @format int32 */
  count?: number;
  result?: MerchantAppointmentQueueDto[] | null;
}

export interface MerchantAppointmentQueueSettlementDto {
  /** @format date-time */
  creationTime?: string;
  /** @format date-time */
  settleDate?: string;
  rrn?: string | null;
  /** @format double */
  amount?: number;
}

export interface MerchantB2CDto {
  /** @format int32 */
  id?: number;
  firstName?: string | null;
  lastName?: string | null;
  location?: LocationDto;
  address?: string | null;
  addressDetail?: string | null;
  template?: string | null;
  isSnappPayEnabled?: boolean;
  isCustomerDepositEnabled?: boolean;
  /** @format double */
  deposit?: number;
  businessInfo?: MerchantBusinessInfoDto;
  socialMedia?: MerchantSocialMediaDto;
  logo?: FileRecord;
  cover?: FileRecord;
  province?: string | null;
  city?: string | null;
  district?: string | null;
  postalCode?: string | null;
  publicPhone?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  users?: MerchantUserB2CDto[] | null;
  merchantWorkScheduleDto?: MerchantWorkScheduleDto;
  serviceCategories?: MerchantServiceCategoryDto[] | null;
  galleries?: MerchantGalleryDto[] | null;
}

export interface MerchantBusinessInfoDto {
  merchantType?: MerchantTypeDto;
  title?: string | null;
  description?: string | null;
  websiteLink?: string | null;
  subDomain?: string | null;
  theme?: string | null;
  voiceType?: string | null;
  seoTitle?: string | null;
  seoDescription?: string | null;
  englishName?: string | null;
  businessType?: BusinessType;
}

export interface MerchantCustomerNotifierCommand {
  notifierType?: MerchantCustomerNotifierType;
  isActive?: boolean;
  /** @format int32 */
  smsTemplateId?: number | null;
  /** @format int32 */
  sendTime?: number;
}

export interface MerchantCustomerNotifierDto {
  type?: MerchantCustomerNotifierType;
  typeDisplay?: string | null;
  isActive?: boolean;
  smsTemplate?: SmsTemplateDto;
  /** @format int32 */
  sendTime?: number;
  templateType?: SmsGroupTemplateType;
}

export interface MerchantDashboardOverviewDto {
  period?: DashboardPeriodDto;
  headline?: DashboardHeadlineDto;
  opportunities?: DashboardOpportunitiesDto;
  appointmentBreakdown?: DashboardAppointmentBreakdownDto;
  customerBreakdown?: DashboardCustomerBreakdownDto;
  paymentSummary?: DashboardPaymentSummaryDto;
  salesTrend?: DashboardSalesTrendPointDto[] | null;
  topServices?: DashboardTopServiceDto[] | null;
  teamPerformance?: DashboardTeamMemberDto[] | null;
}

export interface MerchantDashboardSummaryDto {
  sales?: DashboardSalesDto;
  profit?: DashboardProfitDto;
  staff?: DashboardStaffDto;
  paymentMix?: DashboardPaymentMixDto;
  customers?: DashboardCustomersDto;
  appointments?: DashboardAppointmentsDto;
  dailySales?: DashboardDailySalesDto[] | null;
}

export interface MerchantDto {
  /** @format int32 */
  id?: number;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  location?: LocationDto;
  address?: string | null;
  addressDetail?: string | null;
  email?: string | null;
  referralCode?: string | null;
  status?: VerificationStatus;
  template?: string | null;
  isSnappPayEnabled?: boolean;
  isCustomerDepositEnabled?: boolean;
  /** @format double */
  deposit?: number;
  businessInfo?: MerchantBusinessInfoDto;
  socialMedia?: MerchantSocialMediaDto;
  logo?: FileRecord;
  cover?: FileRecord;
  province?: string | null;
  city?: string | null;
  district?: string | null;
  postalCode?: string | null;
  publicPhone?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface MerchantDtoPageFilterResponse {
  /** @format int32 */
  count?: number;
  result?: MerchantDto[] | null;
}

export interface MerchantFeeDto {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  merchantId?: number;
  payer?: FeePayer;
  isActive?: boolean;
  customerValueType?: FeeValueType;
  /** @format double */
  customerFixedAmount?: number;
  /** @format double */
  customerPercentage?: number;
  merchantValueType?: FeeValueType;
  /** @format double */
  merchantFixedAmount?: number;
  /** @format double */
  merchantPercentage?: number;
  /** @format date-time */
  creationTime?: string;
}

export interface MerchantGalleryDto {
  /** @format int32 */
  id?: number;
  caption?: string | null;
  image?: FileRecord;
  isDefault?: boolean;
  /** @format int32 */
  width?: number | null;
  /** @format int32 */
  height?: number | null;
}

export interface MerchantMarkupDto {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  merchantId?: number;
  markupType?: MarkupType;
  /** @format double */
  fixedAmount?: number;
  /** @format int32 */
  percentageAmount?: number;
  /** @format date-time */
  creationTime?: string;
}

export interface MerchantProfessionalRatingDto {
  /** @format int32 */
  merchantUserId?: number;
  displayName?: string | null;
  /** @format int32 */
  rating?: number;
  attributionValidity?: ReviewAttributionValidity;
}

export interface MerchantReferralDto {
  phoneNumber?: string | null;
  /** @format date-time */
  creationTime?: string;
}

export interface MerchantReviewCountsDto {
  /** @format int32 */
  pending?: number;
  /** @format int32 */
  approved?: number;
  /** @format int32 */
  rejected?: number;
  /** @format int32 */
  published?: number;
}

export interface MerchantReviewCustomerDto {
  /** @format int64 */
  id?: number;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
}

export interface MerchantReviewDetailDto {
  /** @format int64 */
  id?: number;
  /** @format uuid */
  publicId?: string;
  /** @format date-time */
  submittedAtUtc?: string;
  /** @format int32 */
  visitRating?: number;
  text?: string | null;
  subjectMode?: ReviewSubjectMode;
  displayName?: string | null;
  customer?: MerchantReviewCustomerDto;
  moderationStatus?: ReviewModerationStatus;
  visibilityStatus?: ReviewVisibilityStatus;
  publicConsent?: ReviewConsentState;
  contextConsent?: ReviewConsentState;
  replyState?: ReviewReplyState;
  professionalRatings?: MerchantProfessionalRatingDto[] | null;
  serviceTitles?: string[] | null;
  /** @format int32 */
  currentPurchaseId?: number;
  version?: string | null;
  /** @format int32 */
  logicalPurchaseId?: number;
  eligibilityStatus?: ReviewEligibility;
  subjectItemIds?: number[] | null;
  items?: ReviewInvitationItemDto[] | null;
  moderationReasonCode?: ReviewRejectReason;
  moderationReasonText?: string | null;
  /** @format date-time */
  moderatedAtUtc?: string | null;
  /** @format date-time */
  publishedAtUtc?: string | null;
  /** @format date-time */
  hiddenAtUtc?: string | null;
  reply?: MerchantReviewReplyDto;
  audit?: ReviewAuditEntryDto[] | null;
  allowedActions?: string[] | null;
}

export interface MerchantReviewLimitsDto {
  /** @format int32 */
  minRating?: number;
  /** @format int32 */
  maxRating?: number;
  /** @format int32 */
  textMaxLength?: number;
  /** @format int32 */
  displayNameMaxLength?: number;
  /** @format int32 */
  replyMaxLength?: number;
  /** @format int32 */
  reasonMaxLength?: number;
  /** @format int32 */
  maxPageSize?: number;
}

export interface MerchantReviewListDto {
  /** @format int32 */
  totalCount?: number;
  counts?: MerchantReviewCountsDto;
  items?: MerchantReviewListItemDto[] | null;
}

export interface MerchantReviewListItemDto {
  /** @format int64 */
  id?: number;
  /** @format uuid */
  publicId?: string;
  /** @format date-time */
  submittedAtUtc?: string;
  /** @format int32 */
  visitRating?: number;
  text?: string | null;
  subjectMode?: ReviewSubjectMode;
  displayName?: string | null;
  customer?: MerchantReviewCustomerDto;
  moderationStatus?: ReviewModerationStatus;
  visibilityStatus?: ReviewVisibilityStatus;
  publicConsent?: ReviewConsentState;
  contextConsent?: ReviewConsentState;
  replyState?: ReviewReplyState;
  professionalRatings?: MerchantProfessionalRatingDto[] | null;
  serviceTitles?: string[] | null;
  /** @format int32 */
  currentPurchaseId?: number;
  version?: string | null;
}

export interface MerchantReviewMutationResponse {
  /** @format date-time */
  responseTime?: string;
  /** @format int64 */
  reviewId?: number;
  moderationStatus?: ReviewModerationStatus;
  visibilityStatus?: ReviewVisibilityStatus;
  replyState?: ReviewReplyState;
  version?: string | null;
  replyVersion?: string | null;
}

export interface MerchantReviewReplyDto {
  state?: ReviewReplyState;
  draftText?: string | null;
  publishedText?: string | null;
  /** @format date-time */
  publishedAtUtc?: string | null;
  version?: string | null;
}

export interface MerchantServiceCategoryDto {
  /** @format int32 */
  id?: number;
  title?: string | null;
  description?: string | null;
  /** @format date-time */
  creationTime?: string;
  /** @format int32 */
  order?: number;
  services?: MerchantServiceDto[] | null;
}

export interface MerchantServiceDto {
  /** @format int32 */
  id?: number;
  title?: string | null;
  description?: string | null;
  color?: string | null;
  /** @format int32 */
  durationPartInMinute?: number;
  priceType?: MerchantServicePriceType;
  /** @format double */
  startingPrice?: number | null;
  /** @format int32 */
  order?: number;
}

export interface MerchantSocialMediaDto {
  telegramId?: string | null;
  instagramId?: string | null;
  instagramLink?: string | null;
  whatsappNumber?: string | null;
  googleBusinessUrl?: string | null;
  neshanUrl?: string | null;
  baladUrl?: string | null;
}

export interface MerchantTypeDto {
  /** @format int32 */
  id?: number;
  title?: string | null;
  description?: string | null;
}

export interface MerchantUserB2CDto {
  /** @format int32 */
  id?: number;
  jobTitle?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  image?: FileRecord;
  gender?: Gender;
  /** @format date-time */
  birthDate?: string | null;
  /** @format int32 */
  order?: number;
  /** @format date-time */
  updatedAt?: string | null;
  merchantServices?: MerchantServiceDto[] | null;
  portfolio?: MerchantUserPortfolioDto;
}

export interface MerchantUserDto {
  /** @format int32 */
  id?: number;
  status?: MerchantUserStatus;
  jobTitle?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  merchantUserType?: MerchantUserType;
  image?: FileRecord;
  calendarColor?: string | null;
  gender?: Gender;
  /** @format date-time */
  birthDate?: string | null;
  showOnWebsite?: boolean;
  /** @format int32 */
  order?: number;
  merchantServices?: MerchantServiceDto[] | null;
  /** @format int32 */
  markupPercentage?: number;
}

export interface MerchantUserPortfolioDto {
  /** @format int32 */
  merchantUserId?: number;
  description?: string | null;
  images?: MerchantUserPortfolioImageDto[] | null;
}

export interface MerchantUserPortfolioImageDto {
  /** @format int32 */
  id?: number;
  image?: FileRecord;
  description?: string | null;
  /** @format int32 */
  order?: number;
}

export interface MerchantUserSettlementDetailDto {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  merchantUserId?: number;
  merchantUserFullName?: string | null;
  /** @format date-time */
  fromDate?: string;
  /** @format date-time */
  toDate?: string;
  /** @format date-time */
  settleDate?: string;
  rrn?: string | null;
  description?: string | null;
  /** @format int32 */
  itemCount?: number;
  /** @format double */
  grossAmount?: number;
  /** @format double */
  commissionAmount?: number;
  /** @format double */
  totalAmount?: number;
  status?: SettlementStatus;
  /** @format date-time */
  changeStatusTime?: string | null;
  cancelReason?: string | null;
  settledByFullName?: string | null;
  /** @format date-time */
  creationTime?: string;
  items?: MerchantUserSettlementLineDto[] | null;
}

export interface MerchantUserSettlementDto {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  merchantUserId?: number;
  merchantUserFullName?: string | null;
  /** @format date-time */
  fromDate?: string;
  /** @format date-time */
  toDate?: string;
  /** @format date-time */
  settleDate?: string;
  rrn?: string | null;
  description?: string | null;
  /** @format int32 */
  itemCount?: number;
  /** @format double */
  grossAmount?: number;
  /** @format double */
  commissionAmount?: number;
  /** @format double */
  totalAmount?: number;
  status?: SettlementStatus;
  /** @format date-time */
  changeStatusTime?: string | null;
  cancelReason?: string | null;
  settledByFullName?: string | null;
  /** @format date-time */
  creationTime?: string;
}

export interface MerchantUserSettlementDtoPageFilterResponse {
  /** @format int32 */
  count?: number;
  result?: MerchantUserSettlementDto[] | null;
}

export interface MerchantUserSettlementLineDto {
  /** @format int32 */
  customerPurchaseItemId?: number;
  /** @format int32 */
  customerPurchaseId?: number;
  /** @format double */
  grossAmount?: number;
  /** @format double */
  commissionAmount?: number;
  /** @format double */
  amount?: number;
  /** @format double */
  commissionPercentage?: number;
  isActive?: boolean;
}

export interface MerchantUserWithParentDto {
  /** @format int32 */
  id?: number;
  status?: MerchantUserStatus;
  jobTitle?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  merchantUserType?: MerchantUserType;
  image?: FileRecord;
  calendarColor?: string | null;
  gender?: Gender;
  /** @format date-time */
  birthDate?: string | null;
  showOnWebsite?: boolean;
  /** @format int32 */
  order?: number;
  merchantServices?: MerchantServiceDto[] | null;
  /** @format int32 */
  markupPercentage?: number;
  merchantLogo?: FileRecord;
  merchantTitle?: string | null;
  merchantDescription?: string | null;
}

export interface MerchantVerificationDto {
  nationalCode?: string | null;
  /** @format byte */
  nationalCardImage?: Blob | null;
  status?: VerificationStatus;
  adminNote?: string | null;
}

export interface MerchantWorkScheduleCommand {
  /** @format int32 */
  autoGenerateDaysCount?: number;
  weekDays?: MerchantWorkScheduleWeeKDayCommand[] | null;
}

export interface MerchantWorkScheduleDto {
  weekDays?: MerchantWorkScheduleWeekDayDto[] | null;
  /** @format int32 */
  autoGenerateDaysCount?: number;
}

export interface MerchantWorkScheduleTimeSlotCommand {
  startTime?: TimeOnly;
  endTime?: TimeOnly;
}

export interface MerchantWorkScheduleTimeSlotDto {
  startTime?: TimeOnly;
  endTime?: TimeOnly;
}

export interface MerchantWorkScheduleWeeKDayCommand {
  weekDay?: WeekDay;
  timeSlots?: MerchantWorkScheduleTimeSlotCommand[] | null;
}

export interface MerchantWorkScheduleWeekDayDto {
  weekDay?: WeekDay;
  timeSlots?: MerchantWorkScheduleTimeSlotDto[] | null;
}

export interface ModerateReviewCommand {
  decision?: ReviewModerationDecision;
  reasonCode?: ReviewRejectReason;
  reasonText?: string | null;
  expectedVersion?: string | null;
}

export interface NotifyMessageDto {
  /** @format int32 */
  id?: number;
  message?: string | null;
  isOpened?: boolean;
}

export interface NotifyMessageDtoPageFilterResponse {
  /** @format int32 */
  count?: number;
  result?: NotifyMessageDto[] | null;
}

export interface OpenNotifyMessageCommand {
  /** @format int32 */
  id?: number;
}

export interface PaymentInfoDto {
  rrn?: string | null;
  cardNumber?: string | null;
  cardHash?: string | null;
  /** @format double */
  gatewayFee?: number;
  /** @format date-time */
  paymentDate?: string | null;
}

export interface PlaceAppointmentCommandItem {
  date?: DateOnly;
  startTime?: TimeOnly;
  /** @format int32 */
  merchantServiceId?: number;
  /** @format int32 */
  merchantUserId?: number;
}

export interface PlaceAppointmentCommandResponse {
  /** @format date-time */
  responseTime?: string;
  /** @format int64 */
  appointmentQueueId?: number;
  /** @format double */
  totalPrice?: number | null;
  gatewayCallbackUrl?: string | null;
}

export interface PlaceAppointmentsCommand {
  /** @format int64 */
  customerId?: number;
  description?: string | null;
  isConfirmed?: boolean;
  services?: PlaceAppointmentCommandItem[] | null;
}

export interface PlaceHolderDto {
  key?: string | null;
  propertyName?: string | null;
  value?: string | null;
  preView?: string | null;
  hasValue?: boolean;
  applicableTypes?: SmsType[] | null;
}

export interface ProfessionalRatingInput {
  /** @format int32 */
  merchantUserId?: number;
  /** @format double */
  rating?: number | null;
  purchaseItemIds?: number[] | null;
}

export interface ProfessionalRatingSummaryDto {
  enabled?: boolean;
  aggregationScope?: string | null;
  policyVersion?: string | null;
  items?: ProfessionalRatingSummaryItemDto[] | null;
}

export interface ProfessionalRatingSummaryItemDto {
  /** @format int32 */
  merchantUserId?: number;
  /** @format double */
  average?: number | null;
  /** @format int32 */
  ratingCount?: number;
}

export interface ProfessionalRatingSummaryRequest {
  subDomain?: string | null;
  merchantUserIds?: number[] | null;
}

export interface PublicProfessionalRatingDto {
  /** @format int32 */
  merchantUserId?: number;
  displayName?: string | null;
  /** @format int32 */
  rating?: number;
  textAppliesToProfessional?: boolean;
}

export interface PublicReviewContextItemDto {
  /** @format int32 */
  serviceId?: number;
  serviceTitle?: string | null;
  professional?: PublicReviewProfessionalDto;
}

export interface PublicReviewDto {
  /** @format uuid */
  reviewPublicId?: string;
  displayName?: string | null;
  /** @format date-time */
  submittedAtUtc?: string;
  /** @format int32 */
  visitRating?: number;
  text?: string | null;
  verificationLabel?: string | null;
  contextVisible?: boolean;
  contextItems?: PublicReviewContextItemDto[] | null;
  professionalRatings?: PublicProfessionalRatingDto[] | null;
  reply?: PublicReviewReplyDto;
}

export interface PublicReviewPageDto {
  items?: PublicReviewDto[] | null;
  nextCursor?: string | null;
  /** @format int32 */
  totalCount?: number;
}

export interface PublicReviewProfessionalDto {
  /** @format int32 */
  merchantUserId?: number;
  displayName?: string | null;
}

export interface PublicReviewReplyDto {
  text?: string | null;
  /** @format date-time */
  publishedAtUtc?: string;
}

export interface PublicReviewSummaryDto {
  enabled?: boolean;
  /** @format double */
  average?: number | null;
  /** @format int32 */
  ratingCount?: number;
  /** @format int32 */
  textReviewCount?: number;
  distribution?: RatingBucketDto[] | null;
  aggregationScope?: string | null;
  policyVersion?: string | null;
}

export interface PurchasePaymentInfoDto {
  transactionId?: string | null;
  merchantTitle?: string | null;
  merchantAddress?: string | null;
  merchantAddressDetail?: string | null;
  merchantLogo?: FileRecord;
  description?: string | null;
  /** @format double */
  totalAmount?: number;
  /** @format double */
  discountAmount?: number;
  /** @format double */
  appointmentDiscountAmount?: number;
  /** @format double */
  depositAmount?: number;
  /** @format double */
  directAmount?: number;
  /** @format double */
  creditAmount?: number;
  status?: PurchasePaymentStatus;
  isPayable?: boolean;
  needsInquiry?: boolean;
}

export interface PurchasePaymentLinkResponse {
  /** @format date-time */
  responseTime?: string;
  transactionId?: string | null;
  paymentLinkUrl?: string | null;
}

export interface PurchaseReviewInvitationDto {
  /** @format int32 */
  purchaseId?: number;
  /** @format int32 */
  logicalPurchaseId?: number | null;
  requested?: boolean;
  eligibility?: ReviewEligibility;
  failureCode?: string | null;
  invitation?: ReviewInvitationSummaryDto;
  latestAttempt?: ReviewSendAttemptDto;
  /** @format int32 */
  attemptCount?: number;
  canRetry?: boolean;
  retryDeniedReason?: string | null;
  /** @format date-time */
  retryAfterUtc?: string | null;
  retryMayIncurCharge?: boolean;
}

export interface RateableProfessionalDto {
  /** @format int32 */
  merchantUserId?: number;
  displayName?: string | null;
  image?: FileRecord;
  purchaseItemIds?: number[] | null;
}

export interface RatingBucketDto {
  /** @format int32 */
  rating?: number;
  /** @format int32 */
  count?: number;
}

export interface RefreshTokenCommand {
  /** @format uuid */
  refreshTokenId?: string;
}

export interface RegionDto {
  /** @format int32 */
  id?: number;
  postalCode?: string | null;
  title?: string | null;
  description?: string | null;
}

export interface RejectMerchantVerificationCommand {
  /** @format int32 */
  merchantId?: number;
  adminNote?: string | null;
}

export interface RejectSendSmsRegionRequestCommand {
  /** @format int64 */
  id?: number;
  adminNote?: string | null;
}

export interface RejectSmsTemplateCommand {
  /** @format int32 */
  id?: number;
  adminMessage?: string | null;
}

export interface RemoveCustomerMemberCommand {
  /** @format int32 */
  customerGroupId?: number;
  /** @format int64 */
  customerId?: number;
}

export interface ReorderMerchantServiceCategoriesCommand {
  ids?: number[] | null;
}

export interface ReorderMerchantServicesCommand {
  /** @format int32 */
  serviceCategoryId?: number;
  ids?: number[] | null;
}

export interface ReorderMerchantUsersCommand {
  ids?: number[] | null;
}

export interface RequestHeaders {
  x_app_type?: string | null;
  appType?: AppType;
}

export interface ResetPasswordCommand {
  username?: string | null;
  /** @format uuid */
  securityToken?: string;
  newPassword?: string | null;
}

export interface RetryCustomerPurchaseCommandResponse {
  /** @format date-time */
  responseTime?: string;
  /** @format int32 */
  purchaseId?: number;
  /** @format int32 */
  retriedFromPurchaseId?: number;
  paymentStatus?: PurchasePaymentStatus;
  transactionId?: string | null;
  paymentLinkUrl?: string | null;
}

export interface RetryReviewInvitationCommand {
  reason?: string | null;
}

export interface RetryReviewInvitationResponse {
  /** @format date-time */
  responseTime?: string;
  /** @format uuid */
  invitationId?: string;
  /** @format int32 */
  sequence?: number;
  sendStatus?: ReviewSendState;
  mayIncurNewCharge?: boolean;
}

export interface ReviewAuditEntryDto {
  entityType?: string | null;
  action?: string | null;
  actorType?: ReviewActorType;
  /** @format int32 */
  actorId?: number | null;
  fromState?: string | null;
  toState?: string | null;
  reasonCode?: string | null;
  details?: string | null;
  /** @format date-time */
  occurredAtUtc?: string;
}

export interface ReviewCreditDto {
  /** @format double */
  walletBalance?: number;
  /** @format double */
  estimatedCostPerMessage?: number;
  sufficient?: boolean;
}

export interface ReviewFormLimitsDto {
  /** @format int32 */
  minRating?: number;
  /** @format int32 */
  maxRating?: number;
  /** @format int32 */
  textMaxLength?: number;
  /** @format int32 */
  displayNameMaxLength?: number;
}

export interface ReviewInvitationCapabilitiesDto {
  enabled?: boolean;
  disabledReason?: string | null;
  allowedActions?: string[] | null;
  templateVersion?: string | null;
  templateSample?: string | null;
  /** @format int32 */
  invitationValidityDays?: number;
  limits?: MerchantReviewLimitsDto;
  resend?: ReviewResendPolicyDto;
  credit?: ReviewCreditDto;
  siteAvailable?: boolean;
  consentPolicyVersion?: string | null;
  publicSummaryEnabled?: boolean;
}

export interface ReviewInvitationItemDto {
  /** @format int32 */
  sourcePurchaseItemId?: number;
  /** @format int32 */
  serviceId?: number;
  serviceTitle?: string | null;
  professional?: ReviewProfessionalDto;
  /** @format date-time */
  performedAtUtc?: string | null;
}

export interface ReviewInvitationMessagePreviewDto {
  canSend?: boolean;
  blockers?: string[] | null;
  templateVersion?: string | null;
  message?: string | null;
  /** @format int32 */
  segmentCount?: number;
  /** @format double */
  estimatedCost?: number;
  /** @format double */
  walletBalance?: number;
  sufficientCredit?: boolean;
  recipientMasked?: string | null;
  /** @format int32 */
  validityDays?: number;
}

export interface ReviewInvitationPreviewDto {
  merchant?: ReviewMerchantPublicInfoDto;
  state?: ReviewInvitationState;
  requiresSignIn?: boolean;
}

export interface ReviewInvitationPreviewItem {
  /** @format int32 */
  merchantServiceId?: number;
  /** @format int32 */
  merchantUserId?: number;
}

export interface ReviewInvitationPreviewRequest {
  /** @format int64 */
  customerId?: number;
  items?: ReviewInvitationPreviewItem[] | null;
}

export interface ReviewInvitationResult {
  requested?: boolean;
  /** @format uuid */
  invitationId?: string | null;
  sendStatus?: ReviewSendState;
  failureCode?: string | null;
  canRetry?: boolean;
  /** @format date-time */
  retryAfterUtc?: string | null;
}

export interface ReviewInvitationSummaryDto {
  /** @format uuid */
  invitationId?: string;
  state?: ReviewInvitationState;
  /** @format date-time */
  expiresAtUtc?: string;
  ownerBound?: boolean;
  /** @format int64 */
  reviewId?: number | null;
}

export interface ReviewMerchantPublicInfoDto {
  title?: string | null;
  subDomain?: string | null;
  logo?: FileRecord;
  theme?: string | null;
}

export interface ReviewProfessionalDto {
  /** @format int32 */
  merchantUserId?: number;
  displayName?: string | null;
  image?: FileRecord;
}

export interface ReviewRequestStatusDto {
  requestId?: string | null;
  status?: string | null;
  /** @format int32 */
  purchaseId?: number | null;
  result?: CreateCustomerPurchaseCommandResponse;
}

export interface ReviewResendPolicyDto {
  /** @format int32 */
  cooldownMinutes?: number;
  /** @format int32 */
  maxAttempts?: number;
  costsNewCharge?: boolean;
}

export interface ReviewSendAttemptDto {
  /** @format int32 */
  sequence?: number;
  kind?: ReviewSendKind;
  sendStatus?: ReviewSendState;
  failureCode?: string | null;
  /** @format date-time */
  requestedAtUtc?: string;
  /** @format date-time */
  scheduledForUtc?: string | null;
  /** @format date-time */
  sentAtUtc?: string | null;
  /** @format date-time */
  deliveredAtUtc?: string | null;
  /** @format double */
  cost?: number | null;
  /** @format int32 */
  segmentCount?: number | null;
  billingStatus?: ReviewBillingStatus;
}

export interface SaveReviewReplyCommand {
  action?: ReviewReplyAction;
  text?: string | null;
  expectedVersion?: string | null;
}

export interface SendOtpCodeCommand {
  username?: string | null;
}

export interface SendSmsRegionRequest {
  /** @format int32 */
  smsTemplateId?: number;
  regionPostalCode?: string | null;
  gender?: Gender;
  simCardOperator?: SimCardOperator;
  /** @format int32 */
  sendCount?: number;
}

export interface SendSmsRegionResponse {
  /** @format date-time */
  responseTime?: string;
  /** @format int32 */
  mobileNumbersCount?: number;
  /** @format double */
  amount?: number;
  isSuccess?: boolean;
  description?: string | null;
}

export interface SendSmsRequestCommand {
  /** @format int32 */
  smsTemplateId?: number;
  customerIds?: number[] | null;
}

export interface SendSmsRequestGroupCommand {
  /** @format int32 */
  smsTemplateId?: number;
  /** @format int32 */
  groupId?: number;
}

export interface SendSmsRequestSmartAudienceCommand {
  /** @format int32 */
  smsTemplateId?: number;
  audienceKey?: string | null;
  /** @format int32 */
  merchantUserId?: number | null;
  excludeCustomerIds?: number[] | null;
}

export interface SendSmsRequestSpecialGroupCommand {
  /** @format int32 */
  smsTemplateId?: number;
  /** @format int32 */
  groupId?: number;
}

export interface ServiceItemPrice {
  type?: ServiceType;
  title?: string | null;
  /** @format double */
  price?: number;
  /** @format int32 */
  order?: number;
}

export interface SetMerchantCustomerDepositCommand {
  /** @format int32 */
  merchantId?: number;
  isEnabled?: boolean;
}

export interface SetMerchantGalleryDefaultCommand {
  /** @format int32 */
  id?: number;
}

export interface SetMerchantSnappPayEnabledCommand {
  /** @format int32 */
  merchantId?: number;
  isEnabled?: boolean;
}

export interface SettlementPayableItemDto {
  /** @format int32 */
  customerPurchaseItemId?: number;
  /** @format int32 */
  customerPurchaseId?: number;
  /** @format date-time */
  purchaseDate?: string;
  /** @format int32 */
  merchantUserId?: number;
  merchantUserFullName?: string | null;
  customerFullName?: string | null;
  serviceTitle?: string | null;
  /** @format double */
  grossAmount?: number;
  /** @format float */
  commissionPercentage?: number;
  /** @format double */
  commissionAmount?: number;
  /** @format double */
  payableAmount?: number;
}

export interface SettlementPayableItemDtoPageFilterResponse {
  /** @format int32 */
  count?: number;
  result?: SettlementPayableItemDto[] | null;
}

export interface SettlementPayableSummaryDto {
  /** @format int32 */
  merchantUserId?: number;
  merchantUserFullName?: string | null;
  merchantUserType?: MerchantUserType;
  /** @format int32 */
  itemCount?: number;
  /** @format double */
  grossAmount?: number;
  /** @format double */
  commissionAmount?: number;
  /** @format double */
  payableAmount?: number;
}

export interface SettleMerchantAppointmentQueueCommand {
  ids?: number[] | null;
  /** @format date-time */
  settleDate?: string;
  rrn?: string | null;
  /** @format double */
  amount?: number;
}

export interface SignInCommand {
  username?: string | null;
  password?: string | null;
}

export interface SignUpCommand {
  mobileNumber?: string | null;
}

export interface SimpleCustomerDto {
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
}

export interface SimpleCustomerDtoV2 {
  /** @format int64 */
  id?: number;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  owner?: boolean;
}

export interface SimpleMerchantDto {
  /** @format int32 */
  id?: number;
  firstName?: string | null;
  lastName?: string | null;
  address?: string | null;
  addressDetail?: string | null;
  businessInfo?: MerchantBusinessInfoDto;
  logo?: FileRecord;
}

export interface SmartAudienceCalculatedAmountDto {
  /** @format double */
  sumAmount?: number;
  /** @format int32 */
  smsCount?: number;
  /** @format int32 */
  customerCount?: number;
}

export interface SmartAudienceCustomerRowDto {
  /** @format int64 */
  customerId?: number;
  fullName?: string | null;
  phoneNumber?: string | null;
  /** @format date-time */
  lastVisitDate?: string | null;
  serviceTitle?: string | null;
  merchantUserName?: string | null;
}

export interface SmartAudienceCustomersPageDto {
  /** @format int32 */
  count?: number;
  result?: SmartAudienceCustomerRowDto[] | null;
}

export interface SmartAudienceDiscountCommand {
  /** @format date-time */
  expireDate?: string;
  expireTime?: TimeSpan;
  discountType?: DiscountType;
  /** @format double */
  amount?: number;
  /** @format int32 */
  percent?: number;
  /** @format double */
  maximumAmount?: number | null;
  /** @format double */
  minimumAmount?: number | null;
  /** @format int32 */
  count?: number;
  /** @format int32 */
  smsTemplateId?: number;
  audienceKey?: string | null;
  /** @format int32 */
  merchantUserId?: number | null;
  excludeCustomerIds?: number[] | null;
  discountCode?: string | null;
}

export interface SmartAudienceListItemDto {
  key?: string | null;
  kind?: SmartAudienceKind;
  /** @format int32 */
  customerCount?: number;
  /** @format int32 */
  priority?: number;
  service?: SmartAudienceServiceDto;
  /** @format int32 */
  days?: number | null;
  /** @format date-time */
  eventDate?: string | null;
  /** @format double */
  estimatedRevenue?: number | null;
  /** @format date-time */
  lastSentAt?: string | null;
}

export interface SmartAudienceServiceDto {
  ruleKey?: string | null;
  title?: string | null;
}

export interface SmartAudienceSmsTemplateDto {
  /** @format int32 */
  id?: number;
  title?: string | null;
  text?: string | null;
  status?: SmsTemplateStatus;
  smsTypes?: SmsType[] | null;
  recommended?: boolean;
}

export interface SmsCalculatedResponseDto {
  /** @format double */
  sumAmount?: number;
  /** @format int32 */
  smsCount?: number;
}

export interface SmsGroupTemplateDto {
  title?: string | null;
  templates?: SmsTemplateDto[] | null;
}

export interface SmsRequestDto {
  /** @format int64 */
  id?: number;
  /** @format date-time */
  creationTime?: string;
  sendToAll?: boolean;
  /** @format double */
  sumAmount?: number;
  /** @format int32 */
  itemsCount?: number;
  /** @format int32 */
  smsCount?: number;
  message?: string | null;
  serviceType?: ServiceType;
  status?: SmsRequestStatus;
  adminNote?: string | null;
}

export interface SmsRequestDtoPageFilterResponse {
  /** @format int32 */
  count?: number;
  result?: SmsRequestDto[] | null;
}

export interface SmsTemplateDto {
  /** @format int32 */
  id?: number;
  title?: string | null;
  text?: string | null;
  status?: SmsTemplateStatus;
  adminMessage?: string | null;
  applicableSmsTypes?: SmsType[] | null;
}

export interface SnappPayEligibilityCommand {
  /** @format double */
  amount?: number;
}

export interface SnappPayEligibilityResponse {
  /** @format date-time */
  responseTime?: string;
  eligible?: boolean;
  title?: string | null;
  description?: string | null;
}

export interface SnappPayInquiryResponse {
  /** @format date-time */
  responseTime?: string;
  isSuccess?: boolean;
  status?: SnappPayStatus;
  message?: string | null;
}

export interface SubmitCustomerReviewCommand {
  /** @format double */
  visitRating?: number | null;
  text?: string | null;
  subjectMode?: ReviewSubjectMode;
  subjectItemIds?: number[] | null;
  professionalRatings?: ProfessionalRatingInput[] | null;
  publicConsent?: boolean;
  contextConsent?: boolean;
  displayName?: string | null;
  consentPolicyVersion?: string | null;
}

export interface SubmitCustomerReviewResponse {
  /** @format date-time */
  responseTime?: string;
  /** @format uuid */
  reviewPublicId?: string;
  moderationStatus?: ReviewModerationStatus;
  visibilityStatus?: ReviewVisibilityStatus;
  /** @format date-time */
  submittedAtUtc?: string;
  version?: string | null;
}

export interface TimeOnly {
  /** @format int32 */
  hour?: number;
  /** @format int32 */
  minute?: number;
  /** @format int32 */
  second?: number;
  /** @format int32 */
  millisecond?: number;
  /** @format int32 */
  microsecond?: number;
  /** @format int32 */
  nanosecond?: number;
  /** @format int64 */
  ticks?: number;
}

export interface TimeSpan {
  /** @format int64 */
  ticks?: number;
  /** @format int32 */
  days?: number;
  /** @format int32 */
  hours?: number;
  /** @format int32 */
  milliseconds?: number;
  /** @format int32 */
  microseconds?: number;
  /** @format int32 */
  nanoseconds?: number;
  /** @format int32 */
  minutes?: number;
  /** @format int32 */
  seconds?: number;
  /** @format double */
  totalDays?: number;
  /** @format double */
  totalHours?: number;
  /** @format double */
  totalMilliseconds?: number;
  /** @format double */
  totalMicroseconds?: number;
  /** @format double */
  totalNanoseconds?: number;
  /** @format double */
  totalMinutes?: number;
  /** @format double */
  totalSeconds?: number;
}

export interface TransactionCreditResponse {
  /** @format date-time */
  responseTime?: string;
  redirectUrl?: string | null;
}

export interface UnassignCustomerOwnersCommand {
  customerIds?: number[] | null;
  merchantUserIds?: number[] | null;
}

export interface UnassignCustomerOwnersCommandResponse {
  /** @format date-time */
  responseTime?: string;
  /** @format int32 */
  removedCount?: number;
}

export interface UpdateAppInfoUserCommand {
  imei?: string | null;
}

export interface UpdateCustomerCommand {
  /** @format int64 */
  customerId?: number;
  phoneNumber?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  /** @format date-time */
  birthDate?: string | null;
  /** @format date-time */
  dateOfMarriage?: string | null;
  gender?: Gender;
}

export interface UpdateMerchantAddressCommand {
  address?: string | null;
  addressDetail?: string | null;
  location?: LocationCommand;
  province?: string | null;
  city?: string | null;
  district?: string | null;
  postalCode?: string | null;
}

export interface UpdateMerchantBusinessCommand {
  /** @format int32 */
  merchantTypeId?: number;
  title?: string | null;
  description?: string | null;
  websiteLink?: string | null;
  subDomain?: string | null;
  theme?: string | null;
  voiceType?: string | null;
  seoTitle?: string | null;
  seoDescription?: string | null;
  englishName?: string | null;
  businessType?: BusinessType;
}

export interface UpdateMerchantGalleryCaptionCommand {
  /** @format int32 */
  id?: number;
  caption?: string | null;
}

export interface UpdateMerchantInfoCommand {
  firstName?: string | null;
  lastName?: string | null;
}

export interface UpdateMerchantMarkupCommand {
  /** @format int32 */
  merchantId?: number;
  markupType?: MarkupType;
  /** @format double */
  fixedAmount?: number;
  /** @format int32 */
  percentageAmount?: number;
  isActive?: boolean;
}

export interface UpdateMerchantNationalCodeCommand {
  nationalCode?: string | null;
}

export interface UpdateMerchantServiceCategoryCommand {
  /** @format int32 */
  id?: number;
  title?: string | null;
  description?: string | null;
}

export interface UpdateMerchantServiceCommand {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  serviceCategoryId?: number;
  title?: string | null;
  description?: string | null;
  color?: string | null;
  /** @format int32 */
  durationPartInMinute?: number;
  priceType?: MerchantServicePriceType;
  /** @format double */
  startingPrice?: number | null;
}

export interface UpdateMerchantSmsTemplateCommand {
  /** @format int32 */
  id?: number;
  title?: string | null;
  text?: string | null;
}

export interface UpdateMerchantSocialMediaCommand {
  email?: string | null;
  telegramId?: string | null;
  instagramId?: string | null;
  instagramLink?: string | null;
  whatsappNumber?: string | null;
  publicPhone?: string | null;
  googleBusinessUrl?: string | null;
  neshanUrl?: string | null;
  baladUrl?: string | null;
}

export interface UpdateMerchantTemplateCommand {
  template?: string | null;
}

export interface UpdateMerchantUserPortfolioCommand {
  /** @format int32 */
  merchantUserId?: number;
  description?: string | null;
  images?: UpdateMerchantUserPortfolioImageItem[] | null;
}

export interface UpdateMerchantUserPortfolioImageItem {
  /** @format int32 */
  id?: number;
  description?: string | null;
}

export interface UpdateMerchantUserServicesCommand {
  /** @format int32 */
  merchantUserId?: number;
  serviceIds?: number[] | null;
}

export interface UpsertMerchantFeeCommand {
  /** @format int32 */
  merchantId?: number;
  payer?: FeePayer;
  isActive?: boolean;
  customerValueType?: FeeValueType;
  /** @format double */
  customerFixedAmount?: number;
  /** @format double */
  customerPercentage?: number;
  merchantValueType?: FeeValueType;
  /** @format double */
  merchantFixedAmount?: number;
  /** @format double */
  merchantPercentage?: number;
}

export interface UserAppointmentsDto {
  appointmentCalendar?: AppointmentCalendarDto[] | null;
  user?: MerchantUserDto;
}

export interface UserInfoModel {
  /** @format int32 */
  userId?: number;
  mobileNumber?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

export interface UserVerifyOtpCommand {
  username?: string | null;
  otpCode?: string | null;
}

export interface UserWorkScheduleAppointmentDto {
  workScheduleCalendar?: WorkScheduleCalendarDto[] | null;
  user?: MerchantUserDto;
}

export interface ValidateDiscountDto {
  isValid?: boolean;
  /** @format double */
  amount?: number;
  /** @format double */
  finalAmount?: number;
  message?: string | null;
}

export interface VerificationInquiryCommand {
  /** @format int32 */
  merchantId?: number;
}

export interface VerifyForgetPasswordOtpCommand {
  username?: string | null;
  otpCode?: string | null;
}

export interface VerifySignUpCommand {
  firstName?: string | null;
  lastName?: string | null;
  mobileNumber?: string | null;
  email?: string | null;
  password?: string | null;
  nationalCode?: string | null;
  otpCode?: string | null;
  imei?: string | null;
  referralCode?: string | null;
  merchantUserType?: MerchantUserType;
}

export interface WithdrawReviewConsentCommand {
  publicConsent?: boolean | null;
  contextConsent?: boolean | null;
  expectedVersion?: string | null;
}

export interface WithdrawReviewConsentResponse {
  /** @format date-time */
  responseTime?: string;
  publicConsent?: ReviewConsentState;
  contextConsent?: ReviewConsentState;
  visibilityStatus?: ReviewVisibilityStatus;
  version?: string | null;
}

export type WorkScheduleAppointmentsItemDto = object;

export interface WorkScheduleAppointmentTimeSlotDto {
  startTime?: TimeOnly;
  endTime?: TimeOnly;
  appointmentsItems?: WorkScheduleAppointmentsItemDto[] | null;
}

export interface WorkScheduleCalendarDto {
  availableDate?: DateOnly;
  timeSlots?: WorkScheduleAppointmentTimeSlotDto[] | null;
}

export interface AdminAppointmentQueueListParams {
  Status?: AppointmentStatus;
  /** @format int64 */
  CustomerId?: number;
  /** @format int32 */
  MerchantUserId?: number;
  /** @format date-time */
  CreationTimeFrom?: string;
  /** @format date-time */
  CreationTimeTo?: string;
  /** @format int32 */
  MerchantId?: number;
  HasSettlement?: boolean;
  PaymentType?: PaymentType;
  HasPayment?: boolean;
  SnappPayTransactionId?: string;
  /** @format int32 */
  Count?: number;
  /** @format int32 */
  Skip?: number;
}

export type AdminAppointmentQueueListData =
  MerchantAppointmentQueueDtoPageFilterResponse;

export type AdminAppointmentQueueSettleUpdateData = CommandResponse;

export type AdminAppointmentQueueCancelUpdateData =
  CancelAppointmentQueueCommandResponse;

export interface AdminCustomerPurchaseListParams {
  /** @format int32 */
  MerchantId?: number;
  /** @format date-time */
  CreationTimeFrom?: string;
  /** @format date-time */
  CreationTimeTo?: string;
  PaymentMethod?: PurchasePaymentMethod;
  CustomerPhoneNumber?: string;
  /** @format int32 */
  PageSize?: number;
  /** @format int32 */
  PageSkip?: number;
  NormalizedCustomerPhoneNumber?: string;
  /** @format int32 */
  Count?: number;
  /** @format int32 */
  Skip?: number;
}

export type AdminCustomerPurchaseListData =
  AdminCustomerPurchaseDtoPageFilterResponse;

export interface AdminMerchantListParams {
  PhoneNumber?: string;
  Status?: VerificationStatus;
  /** @format int32 */
  Count?: number;
  /** @format int32 */
  Skip?: number;
}

export type AdminMerchantListData = MerchantDtoPageFilterResponse;

export interface AdminMerchantVerificationListParams {
  /** @format int32 */
  merchantId?: number;
}

export type AdminMerchantVerificationListData = MerchantVerificationDto;

export type AdminMerchantVerificationInquiryCreateData = CommandResponse;

export type AdminMerchantAcceptUpdateData = CommandResponse;

export type AdminMerchantRejectUpdateData = CommandResponse;

export type AdminMerchantSnappPayUpdateData = CommandResponse;

export type AdminMerchantCustomerDepositUpdateData = CommandResponse;

export interface AdminMerchantFeeDetailParams {
  /** @format int32 */
  merchantId: number;
}

export type AdminMerchantFeeDetailData = MerchantFeeDto;

export type AdminMerchantFeeUpdateData = CommandResponse;

export interface AdminMerchantMarkupDetailParams {
  /** @format int32 */
  merchantId: number;
}

export type AdminMerchantMarkupDetailData = MerchantMarkupDto;

export type AdminMerchantMarkupUpdateData = CommandResponse;

export interface AdminSmsReportListParams {
  ServiceType?: ServiceType;
  /** @format date-time */
  FromDate?: string;
  /** @format date-time */
  ToDate?: string;
  Status?: SmsRequestStatus;
  /** @format int32 */
  Count?: number;
  /** @format int32 */
  Skip?: number;
}

export type AdminSmsReportListData = SmsRequestDtoPageFilterResponse;

export type AdminSmsReportAcceptUpdateData = CommandResponse;

export type AdminSmsReportRejectUpdateData = CommandResponse;

export interface AdminSmsTemplateDetailParams {
  /** @format int32 */
  id: number;
}

export type AdminSmsTemplateDetailData = AdminSmsTemplateDto;

export interface AdminSmsTemplateListParams {
  Status?: SmsTemplateStatus;
  /** @format int32 */
  Count?: number;
  /** @format int32 */
  Skip?: number;
}

export type AdminSmsTemplateListData = AdminSmsTemplateDtoPageFilterResponse;

export type AdminSmsTemplateAcceptUpdateData = CommandResponse;

export type AdminSmsTemplateRejectUpdateData = CommandResponse;

export interface AdminTransactionListParams {
  /** @format int32 */
  MerchantId?: number;
  /** @format date-time */
  TransactionDateFrom?: string;
  /** @format date-time */
  TransactionDateTo?: string;
  Sources?: AdminTransactionSource[];
  BankGateway?: BankGateway;
  Status?: AdminTransactionStatus;
  Direction?: AdminTransactionDirection;
  CustomerPhoneNumber?: string;
  ReferenceNumber?: string;
  /** @format int32 */
  PageSize?: number;
  /** @format int32 */
  PageSkip?: number;
  NormalizedCustomerPhoneNumber?: string;
  NormalizedReferenceNumber?: string;
  /** @format int32 */
  Count?: number;
  /** @format int32 */
  Skip?: number;
}

export type AdminTransactionListData = AdminTransactionReportDto;

export type AppDownloadApkListData = any;

export type AppInfoCreateData = any;

export type AppInfoChangeUpdateData = any;

export interface B2CAppointmentListParams {
  /** @format int32 */
  merchantUserId?: number;
  fromDate?: DateOnly;
  toDate?: DateOnly;
}

export type B2CAppointmentListData = AppointmentCalendarB2CDto[];

export type B2CAppointmentCreateData = PlaceAppointmentCommandResponse;

export interface B2CAppointmentQueueDetailsListParams {
  /** @format int64 */
  appointmentQueueId: number;
}

export type B2CAppointmentQueueDetailsListData = AppointmentQueueDto;

export interface B2CAppointmentMyAppointmentsListParams {
  /** @format int32 */
  merchantId?: number;
}

export type B2CAppointmentMyAppointmentsListData = AppointmentDetailDto[];

export interface AppointmentListParams {
  /** @format date-time */
  fromDate?: string;
  /** @format date-time */
  toDate?: string;
}

export type AppointmentListData = UserAppointmentsDto[];

export type AppointmentCreateData = PlaceAppointmentCommandResponse;

export type AppointmentCancelUpdateData = CancelAppointmentCommandResponse;

export type B2CAppointmentQueuePayCreateData = PlaceAppointmentCommandResponse;

export type B2CAppointmentQueueSnappPayEligibilityCreateData =
  AppointmentSnappPayEligibilityResponse;

export interface B2CAppointmentQueueSnappPayInquiryCreateParams {
  /** @format int64 */
  appointmentQueueId: number;
}

export type B2CAppointmentQueueSnappPayInquiryCreateData =
  AppointmentSnappPayInquiryResponse;

export interface AppointmentQueueListParams {
  Status?: AppointmentStatus;
  /** @format int64 */
  CustomerId?: number;
  /** @format int32 */
  MerchantUserId?: number;
  /** @format date-time */
  CreationTimeFrom?: string;
  /** @format date-time */
  CreationTimeTo?: string;
  /** @format date-time */
  AppointmentDateFrom?: string;
  /** @format date-time */
  AppointmentDateTo?: string;
  HasSettlement?: boolean;
  PaymentType?: PaymentType;
  HasPayment?: boolean;
  SnappPayTransactionId?: string;
  /** @format int32 */
  Count?: number;
  /** @format int32 */
  Skip?: number;
}

export type AppointmentQueueListData =
  MerchantAppointmentQueueDtoPageFilterResponse;

export interface AppointmentQueueByAppointmentIdListParams {
  /** @format int64 */
  appointmentId?: number;
}

export type AppointmentQueueByAppointmentIdListData = UserAppointmentsDto[];

export interface AppointmentQueueDetailParams {
  /** @format int64 */
  appointmentQueueId: number;
}

export type AppointmentQueueDetailData = MerchantAppointmentQueueDto;

export type AppointmentQueueCancelUpdateData =
  CancelAppointmentQueueCommandResponse;

export type AuthenticateCheckUserCreateData = any;

export type AuthenticateSignInCreateData = any;

export type AuthenticateSignInWithOtpCreateData = any;

export type AuthenticateVerifyOtpLoginCreateData = any;

export type AuthenticateSignUpCreateData = any;

export type AuthenticateVerifySignUpCreateData = any;

export type AuthenticateForgetPasswordOtpCreateData = any;

export type AuthenticateVerifyOtpForgetPasswordCreateData = any;

export type AuthenticateResetPasswordCreateData = any;

export type AuthenticateRefreshTokenCreateData = any;

export type BalanceListData = IWalletBalanceDto;

export interface BarberDashboardOverviewListParams {
  /** @format int32 */
  MerchantUserId?: number;
  /** @format int32 */
  InactiveDays?: number;
  /** @format int32 */
  LapsedDays?: number;
  /** @format int32 */
  TopCount?: number;
  /** @format int32 */
  BirthdayWindowDays?: number;
  /** @format int32 */
  UpcomingCount?: number;
  /** @format date-time */
  FromDate?: string;
  /** @format date-time */
  ToDate?: string;
}

export type BarberDashboardOverviewListData = BarberDashboardOverviewDto;

export type ContactUsCreateData = CommandResponse;

export type CustomerCreateData = CreateCustomerCommandResponse;

export type CustomerUpdateData = CommandResponse;

export interface CustomerListParams {
  Term?: string;
  /** @format int32 */
  Count?: number;
  /** @format int32 */
  Skip?: number;
}

export type CustomerListData = CustomerDtoPageFilterResponse;

export type CustomerDeleteData = CommandResponse;

export type CustomerAddOwnerCreateData = CommandResponse;

export type CustomerAssignOwnersCreateData =
  AssignCustomerOwnersCommandResponse;

export type CustomerUnassignOwnersCreateData =
  UnassignCustomerOwnersCommandResponse;

export type CustomerBulkCreateData = CreateCustomersCommandResponse;

export interface CustomerMobileNumberListParams {
  mobileNumber?: string;
}

export type CustomerMobileNumberListData = SimpleCustomerDtoV2;

export interface CustomerInfoListParams {
  phoneNumber?: string;
}

export type CustomerInfoListData = CustomerInfoDto;

export interface CustomerInfoDetailParams {
  /** @format int64 */
  id: number;
}

export type CustomerInfoDetailData = CustomerInfoDto;

export interface CustomerGroupsListParams {
  /** @format int64 */
  id?: number;
}

export type CustomerGroupsListData = CustomerGroupDto[];

export type CustomerAuthCheckCustomerCreateData = any;

export type CustomerAuthSignInCreateData = any;

export type CustomerAuthSignInWithOtpCreateData = any;

export type CustomerAuthVerifyOtpLoginCreateData = any;

export type CustomerAuthSignUpCreateData = any;

export type CustomerAuthVerifySignUpCreateData = any;

export type CustomerAuthForgetPasswordOtpCreateData = any;

export type CustomerAuthVerifyOtpForgetPasswordCreateData = any;

export type CustomerAuthResetPasswordCreateData = any;

export type CustomerAuthRefreshTokenCreateData = any;

export interface CustomerDiscountListParams {
  /** @format int64 */
  customerId: number;
}

export type CustomerDiscountListData = DiscountDto[];

export interface CustomerGroupListParams {
  Term?: string;
  /** @format int32 */
  Count?: number;
  /** @format int32 */
  Skip?: number;
}

export type CustomerGroupListData = CustomerGroupDtoPageFilterResponse;

export type CustomerGroupCreateData = CommandResponse;

export type CustomerGroupDeleteData = CommandResponse;

export type CustomerGroupMemberCreateData = CommandResponse;

export type CustomerGroupMemberDeleteData = CommandResponse;

export type CustomerGroupBulkMemberCreateData = CommandResponse;

export interface CustomerGroupMembersListParams {
  Term?: string;
  /** @format int32 */
  Count?: number;
  /** @format int32 */
  Skip?: number;
  /** @format int32 */
  customerGroupId: number;
}

export type CustomerGroupMembersListData = CustomerDtoPageFilterResponse;

export interface CustomerGroupMembersCountListParams {
  /** @format int32 */
  customerGroupId: number;
}

/** @format int32 */
export type CustomerGroupMembersCountListData = number;

export interface CustomerNotifierCheckBalanceListParams {
  notifierType?: MerchantCustomerNotifierType;
}

export type CustomerNotifierCheckBalanceListData = CheckCustomerNotifierDto;

export interface CustomerPurchaseListParams {
  /** @format date-time */
  FromDate?: string;
  /** @format date-time */
  ToDate?: string;
  /** @format int32 */
  Count?: number;
  /** @format int32 */
  Skip?: number;
}

export type CustomerPurchaseListData = CustomerPurchaseDto[];

export type CustomerPurchaseCreateData = CreateCustomerPurchaseCommandResponse;

export interface CustomerPurchaseDetailParams {
  /** @format int32 */
  purchaseId: number;
}

export type CustomerPurchaseDetailData = CustomerPurchaseDetailDto;

export interface CustomerPurchaseReviewInvitationListParams {
  /** @format int32 */
  purchaseId: number;
}

export type CustomerPurchaseReviewInvitationListData =
  PurchaseReviewInvitationDto;

export type CustomerPurchaseSnappPayEligibilityCreateData =
  SnappPayEligibilityResponse;

export interface CustomerPurchasePaymentLinkResendCreateParams {
  /** @format int32 */
  purchaseId: number;
}

export type CustomerPurchasePaymentLinkResendCreateData =
  PurchasePaymentLinkResponse;

export interface CustomerPurchaseRetryCreateParams {
  /** @format int32 */
  purchaseId: number;
}

export type CustomerPurchaseRetryCreateData =
  RetryCustomerPurchaseCommandResponse;

export type CustomerPurchaseSnappPayCancelCreateData = CommandResponse;

export interface B2CReviewInvitationPreviewListParams {
  subDomain?: string;
  token: string;
}

export type B2CReviewInvitationPreviewListData = ReviewInvitationPreviewDto;

export interface B2CReviewInvitationDetailParams {
  subDomain?: string;
  token: string;
}

export type B2CReviewInvitationDetailData = CustomerInvitationDto;

export interface B2CReviewInvitationReviewCreateParams {
  subDomain?: string;
  token: string;
}

export type B2CReviewInvitationReviewCreateData = SubmitCustomerReviewResponse;

export interface B2CDiscountValidateListParams {
  /** @format int32 */
  MerchantId?: number;
  DiscountCode?: string;
  /** @format double */
  PurchaseAmount?: number;
}

export type B2CDiscountValidateListData = ValidateDiscountDto;

export interface DiscountValidateListParams {
  /** @format int64 */
  CustomerId?: number;
  DiscountCode?: string;
  /** @format double */
  PurchaseAmount?: number;
}

export type DiscountValidateListData = ValidateDiscountDto;

export type DiscountCustomerGroupCreateData = CommandResponse;

export type DiscountCustomerGroupCalculateSmsAmountCreateData =
  SmsCalculatedResponseDto;

export type DiscountGroupCreateData = CommandResponse;

export type DiscountGroupCalculateSmsAmountCreateData =
  SmsCalculatedResponseDto;

export interface DiscountDetailParams {
  code: string;
}

export type DiscountDetailData = DiscountWithCustomerDto;

export type DiscountGroupListData = DiscountGroupDto[];

export interface DiscountGroupCountDetailParams {
  /** @format int32 */
  id: number;
}

/** @format int32 */
export type DiscountGroupCountDetailData = number;

export interface FileListParams {
  fileName?: string;
  bucket?: string;
  /** @format int32 */
  w?: number;
  format?: string;
}

/** @format binary */
export type FileListData = File;

export interface B2CMerchantMarkupDetailParams {
  /** @format int32 */
  merchantId: number;
}

export type B2CMerchantMarkupDetailData = MerchantMarkupDto;

export interface B2CMerchantListParams {
  subDomain?: string;
}

export type B2CMerchantListData = MerchantB2CDto;

export type B2CMerchantTemplateUpdateData = CommandResponse;

export type MerchantListData = MerchantDto;

export type MerchantUpdateData = CommandResponse;

export type MerchantAddressUpdateData = CommandResponse;

export type MerchantBusinessUpdateData = CommandResponse;

export type MerchantSocialMediaUpdateData = CommandResponse;

export type MerchantCustomerNotifierListData = MerchantCustomerNotifierDto[];

export type MerchantCustomerNotifierUpdateData = CommandResponse;

export type MerchantCustomersCountListData = Record<string, string>;

export type MerchantReferralsListData = MerchantReferralDto[];

export interface MerchantLogoUpdatePayload {
  ContentType?: string;
  ContentDisposition?: string;
  Headers?: Record<string, string[]>;
  /** @format int64 */
  Length?: number;
  Name?: string;
  FileName?: string;
}

export type MerchantLogoUpdateData = CommandResponse;

export interface MerchantCoverUpdatePayload {
  ContentType?: string;
  ContentDisposition?: string;
  Headers?: Record<string, string[]>;
  /** @format int64 */
  Length?: number;
  Name?: string;
  FileName?: string;
}

export type MerchantCoverUpdateData = CommandResponse;

export interface MerchantDashboardOverviewListParams {
  /** @format int32 */
  InactiveDays?: number;
  /** @format int32 */
  LapsedDays?: number;
  /** @format int32 */
  TopCount?: number;
  /** @format date-time */
  FromDate?: string;
  /** @format date-time */
  ToDate?: string;
}

export type MerchantDashboardOverviewListData = MerchantDashboardOverviewDto;

export interface MerchantDashboardSummaryListParams {
  /** @format date-time */
  FromDate?: string;
  /** @format date-time */
  ToDate?: string;
}

export type MerchantDashboardSummaryListData = MerchantDashboardSummaryDto;

export interface MerchantDashboardBarbersListParams {
  /** @format date-time */
  FromDate?: string;
  /** @format date-time */
  ToDate?: string;
}

export type MerchantDashboardBarbersListData = DashboardBarberDto[];

export interface MerchantDashboardServicesListParams {
  /** @format date-time */
  FromDate?: string;
  /** @format date-time */
  ToDate?: string;
}

export type MerchantDashboardServicesListData = DashboardServiceDto[];

export type MerchantGalleryListData = MerchantGalleryDto[];

export interface MerchantGalleryCreatePayload {
  /** @format int32 */
  "UserInfo.UserId"?: number;
  "UserInfo.MobileNumber"?: string;
  "UserInfo.FirstName"?: string;
  "UserInfo.LastName"?: string;
  Caption?: string;
  /** @format binary */
  File?: File;
  /** @format binary */
  file?: File;
}

export type MerchantGalleryCreateData = CommandResponse;

export interface MerchantGalleryDeleteParams {
  /** @format int32 */
  id?: number;
}

export type MerchantGalleryDeleteData = CommandResponse;

export type MerchantGalleryDefaultUpdateData = CommandResponse;

export type MerchantGalleryCaptionUpdateData = CommandResponse;

export interface MerchantReviewListParams {
  Status?: ReviewModerationStatus;
  Visibility?: ReviewVisibilityStatus;
  PublicConsent?: ReviewConsentState;
  ReplyState?: ReviewReplyState;
  /** @format int32 */
  VisitRating?: number;
  /** @format int32 */
  ProfessionalId?: number;
  /** @format int32 */
  ProfessionalRating?: number;
  /** @format int32 */
  ServiceId?: number;
  /** @format date-time */
  FromUtc?: string;
  /** @format date-time */
  ToUtc?: string;
  Query?: string;
  Sort?: ReviewSort;
  /** @format int32 */
  Count?: number;
  /** @format int32 */
  Skip?: number;
}

export type MerchantReviewListData = MerchantReviewListDto;

export interface MerchantReviewDetailParams {
  /** @format int64 */
  reviewId: number;
}

export type MerchantReviewDetailData = MerchantReviewDetailDto;

export interface MerchantReviewModerationCreateParams {
  /** @format int64 */
  reviewId: number;
}

export type MerchantReviewModerationCreateData = MerchantReviewMutationResponse;

export interface MerchantReviewReplyUpdateParams {
  /** @format int64 */
  reviewId: number;
}

export type MerchantReviewReplyUpdateData = MerchantReviewMutationResponse;

export interface MerchantReviewVisibilityCreateParams {
  /** @format int64 */
  reviewId: number;
}

export type MerchantReviewVisibilityCreateData = MerchantReviewMutationResponse;

export interface MerchantServiceDetailParams {
  /** @format int32 */
  id: number;
}

export type MerchantServiceDetailData = MerchantServiceDto;

export type MerchantServiceCreateData = CommandResponse;

export type MerchantServiceUpdateData = CommandResponse;

export type MerchantServiceOrderUpdateData = CommandResponse;

export type MerchantServiceCategoryListData = MerchantServiceCategoryDto[];

export type MerchantServiceCategoryCreateData = CommandResponse;

export type MerchantServiceCategoryUpdateData = CommandResponse;

export type MerchantServiceCategoryOrderUpdateData = CommandResponse;

export type MerchantTypeListData = MerchantTypeDto[];

export interface MerchantUserGetByMobileNumberListParams {
  mobileNumber?: string;
}

export type MerchantUserGetByMobileNumberListData = MerchantUserWithParentDto;

export type MerchantUserListData = MerchantUserDto[];

export interface MerchantUserCreatePayload {
  /** @format int32 */
  "UserInfo.UserId"?: number;
  "UserInfo.MobileNumber"?: string;
  "UserInfo.FirstName"?: string;
  "UserInfo.LastName"?: string;
  JobTitle?: string;
  FirstName?: string;
  LastName?: string;
  MobileNumber?: string;
  MerchantUserType?: MerchantUserType;
  Gender?: Gender;
  /** @format date-time */
  BirthDate?: string;
  CalendarColor?: string;
  ShowOnWebsite?: boolean;
  ServiceIds?: number[];
  /** @format binary */
  File?: File;
  /** @format int32 */
  MarkupPercentage?: number;
  /** @format binary */
  file?: File;
}

export type MerchantUserCreateData = CommandResponse;

export interface MerchantUserUpdatePayload {
  /** @format int32 */
  "UserInfo.UserId"?: number;
  "UserInfo.MobileNumber"?: string;
  "UserInfo.FirstName"?: string;
  "UserInfo.LastName"?: string;
  /** @format int32 */
  MerchantUserId?: number;
  JobTitle?: string;
  FirstName?: string;
  LastName?: string;
  MerchantUserType?: MerchantUserType;
  /** @format binary */
  File?: File;
  CalendarColor?: string;
  Gender?: Gender;
  ShowOnWebsite?: boolean;
  /** @format date-time */
  BirthDate?: string;
  /** @format int32 */
  MarkupPercentage?: number;
  /** @format binary */
  file?: File;
}

export type MerchantUserUpdateData = CommandResponse;

export interface MerchantUserDetailParams {
  /** @format int32 */
  id: number;
}

export type MerchantUserDetailData = MerchantUserDto[];

export type MerchantUserServiceUpdateData = CommandResponse;

export type MerchantUserOrderUpdateData = CommandResponse;

export interface MerchantUserPortfolioListParams {
  /** @format int32 */
  id: number;
}

export type MerchantUserPortfolioListData = MerchantUserPortfolioDto;

export interface MerchantUserPortfolioImageCreatePayload {
  /** @format int32 */
  "UserInfo.UserId"?: number;
  "UserInfo.MobileNumber"?: string;
  "UserInfo.FirstName"?: string;
  "UserInfo.LastName"?: string;
  /** @format int32 */
  MerchantUserId?: number;
  /** @format binary */
  File?: File;
  Description?: string;
}

export type MerchantUserPortfolioImageCreateData =
  AddMerchantUserPortfolioImageCommandResponse;

export type MerchantUserPortfolioUpdateData = CommandResponse;

export interface MerchantUserSettlementPayableSummaryListParams {
  /** @format int32 */
  MerchantUserId?: number;
  /** @format date-time */
  FromDate?: string;
  /** @format date-time */
  ToDate?: string;
  /** @format int32 */
  Count?: number;
  /** @format int32 */
  Skip?: number;
}

export type MerchantUserSettlementPayableSummaryListData =
  SettlementPayableSummaryDto[];

export interface MerchantUserSettlementPayableListParams {
  /** @format int32 */
  MerchantUserId?: number;
  /** @format date-time */
  FromDate?: string;
  /** @format date-time */
  ToDate?: string;
  /** @format int32 */
  Count?: number;
  /** @format int32 */
  Skip?: number;
}

export type MerchantUserSettlementPayableListData =
  SettlementPayableItemDtoPageFilterResponse;

export type MerchantUserSettlementCreateData =
  CreateMerchantUserSettlementCommandResponse;

export interface MerchantUserSettlementListParams {
  /** @format int32 */
  MerchantUserId?: number;
  /** @format date-time */
  FromDate?: string;
  /** @format date-time */
  ToDate?: string;
  Status?: SettlementStatus;
  /** @format int32 */
  Count?: number;
  /** @format int32 */
  Skip?: number;
}

export type MerchantUserSettlementListData =
  MerchantUserSettlementDtoPageFilterResponse;

export interface MerchantUserSettlementDetailParams {
  /** @format int32 */
  settlementId: number;
}

export type MerchantUserSettlementDetailData = MerchantUserSettlementDetailDto;

export interface MerchantUserSettlementCancelCreateParams {
  /** @format int32 */
  settlementId: number;
}

export type MerchantUserSettlementCancelCreateData = CommandResponse;

export type MerchantVerificationListData = MerchantVerificationDto;

export interface MerchantVerificationNationalCardImageUpdatePayload {
  ContentType?: string;
  ContentDisposition?: string;
  Headers?: Record<string, string[]>;
  /** @format int64 */
  Length?: number;
  Name?: string;
  FileName?: string;
}

export type MerchantVerificationNationalCardImageUpdateData = CommandResponse;

export type MerchantVerificationNationalCodeUpdateData = CommandResponse;

export type MerchantWorkScheduleListData = MerchantWorkScheduleDto[];

export type MerchantWorkScheduleCreateData = CommandResponse;

export interface B2CMeReviewsDetailParams {
  /** @format uuid */
  reviewPublicId: string;
}

export type B2CMeReviewsDetailData = CustomerReviewDto;

export interface B2CMeReviewsConsentPartialUpdateParams {
  /** @format uuid */
  reviewPublicId: string;
}

export type B2CMeReviewsConsentPartialUpdateData =
  WithdrawReviewConsentResponse;

export interface NotifyMessageListParams {
  IsOpened?: boolean;
  Term?: string;
  /** @format int32 */
  Count?: number;
  /** @format int32 */
  Skip?: number;
}

export type NotifyMessageListData = NotifyMessageDtoPageFilterResponse;

export type NotifyMessageUpdateData = CommandResponse;

export type PlaceHolderListData = PlaceHolderDto[];

export interface B2CReviewsListParams {
  SubDomain?: string;
  /** @format int32 */
  ServiceId?: number;
  /** @format int32 */
  ProfessionalId?: number;
  RatingTarget?: ReviewRatingTarget;
  /** @format int32 */
  Rating?: number;
  Sort?: ReviewSort;
  /** @format int32 */
  PageSize?: number;
  Cursor?: string;
}

export type B2CReviewsListData = PublicReviewPageDto;

export interface B2CReviewsSummaryListParams {
  subDomain?: string;
}

export type B2CReviewsSummaryListData = PublicReviewSummaryDto;

export type B2CProfessionalRatingsSummaryCreateData =
  ProfessionalRatingSummaryDto;

export interface PublicPurchasePaymentDetailParams {
  transactionId: string;
}

export type PublicPurchasePaymentDetailData = PurchasePaymentInfoDto;

export interface PublicPurchasePaymentConfirmCreateParams {
  transactionId: string;
}

export type PublicPurchasePaymentConfirmCreateData =
  ConfirmPurchaseCreditPaymentResponse;

export interface PublicPurchasePaymentInquiryCreateParams {
  transactionId: string;
}

export type PublicPurchasePaymentInquiryCreateData = SnappPayInquiryResponse;

export interface ReferralValidateListParams {
  referralCode?: string;
}

export type ReferralValidateListData = any;

export interface RegionListParams {
  Term?: string;
  /** @format int32 */
  Count?: number;
  /** @format int32 */
  Skip?: number;
}

export type RegionListData = RegionDto[];

export type ReviewInvitationCapabilitiesListData =
  ReviewInvitationCapabilitiesDto;

export type ReviewInvitationPreviewCreateData =
  ReviewInvitationMessagePreviewDto;

export interface ReviewInvitationRequestsDetailParams {
  requestId: string;
}

export type ReviewInvitationRequestsDetailData = ReviewRequestStatusDto;

export interface ReviewInvitationRetryCreateParams {
  /** @format uuid */
  invitationId: string;
}

export type ReviewInvitationRetryCreateData = RetryReviewInvitationResponse;

export type ServicePriceListData = ServiceItemPrice[];

export interface SmartAudienceListParams {
  /** @format int32 */
  Take?: number;
  /** @format int32 */
  MerchantUserId?: number;
}

export type SmartAudienceListData = SmartAudienceListItemDto[];

export interface SmartAudienceCustomersListParams {
  /** @format int32 */
  Skip?: number;
  /** @format int32 */
  Count?: number;
  /** @format int32 */
  MerchantUserId?: number;
  audienceKey: string;
}

export type SmartAudienceCustomersListData = SmartAudienceCustomersPageDto;

export interface SmartAudienceTemplatesListParams {
  audienceKey: string;
}

export type SmartAudienceTemplatesListData = SmartAudienceSmsTemplateDto[];

export type SmsCalculateRegionSmsAmountCreateData =
  CalculatedSmsRegionRequestDto;

export type SmsSendRegionRequestCreateData = SendSmsRegionResponse;

export type SmsSendAreaRequestCreateData = SendSmsRegionResponse;

export type SmsCalculateSmsAmountCreateData = SmsCalculatedResponseDto;

export type SmsCalculateSmsGroupAmountCreateData = SmsCalculatedResponseDto;

export type SmsCalculateSmsSpecialGroupAmountCreateData =
  SmsCalculatedResponseDto;

export interface SmsSendRequestListParams {
  ServiceType?: ServiceType;
  /** @format date-time */
  FromDate?: string;
  /** @format date-time */
  ToDate?: string;
  Status?: SmsRequestStatus;
  /** @format int32 */
  Count?: number;
  /** @format int32 */
  Skip?: number;
}

export type SmsSendRequestListData = SmsRequestDtoPageFilterResponse;

export type SmsSendRequestCreateData = CommandResponse;

export type SmsSendRequestGroupCreateData = CommandResponse;

export type SmsSendRequestSpecialGroupCreateData = CommandResponse;

export type SmsCalculateSmartAudienceAmountCreateData =
  SmartAudienceCalculatedAmountDto;

export type SmsSendRequestSmartAudienceCreateData = CommandResponse;

export type SmsCalculateSmartAudienceDiscountAmountCreateData =
  SmartAudienceCalculatedAmountDto;

export type SmsSendSmartAudienceDiscountCreateData = CommandResponse;

export type SmsCalculateCustomersDiscountAmountCreateData =
  SmartAudienceCalculatedAmountDto;

export type SmsSendCustomersDiscountCreateData = CommandResponse;

export interface SmsTemplateListParams {
  templateType?: SmsGroupTemplateType;
}

export type SmsTemplateListData = SmsGroupTemplateDto[];

export type SmsTemplateCreateData = CommandResponse;

export type SmsTemplateUpdateData = CommandResponse;

export type SmsTemplateDeleteData = CommandResponse;

export type TestListData = any;

export type TestGet222ListData = any;

export interface TransactionListParams {
  TransactionSource?: TransactionSource;
  /** @format int32 */
  Count?: number;
  /** @format int32 */
  Skip?: number;
}

export type TransactionListData = ITransactionBaseDtoPageFilterResponse;

export type TransactionCreditCreateData = TransactionCreditResponse;

export interface TransactionCreditListParams {
  /** @format int64 */
  id?: number;
}

export type TransactionCreditListData = ITransactionCreditDto;

export interface B2CWorkScheduleListParams {
  /** @format int32 */
  merchantUserId?: number;
  /** @format date-time */
  fromDate?: string;
  /** @format date-time */
  toDate?: string;
}

export type B2CWorkScheduleListData = WorkScheduleCalendarDto[];

export interface WorkScheduleListParams {
  /** @format date-time */
  fromDate?: string;
  /** @format date-time */
  toDate?: string;
}

export type WorkScheduleListData = UserWorkScheduleAppointmentDto[];

export type WorkScheduleCreateData = CommandResponse;

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Main
 * @version v1
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags AdminAppointmentQueue
     * @name AdminAppointmentQueueList
     * @request GET:/api/AdminAppointmentQueue
     * @secure
     */
    adminAppointmentQueueList: (
      query: AdminAppointmentQueueListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<AdminAppointmentQueueListData, FailedResponse>({
        path: `/api/AdminAppointmentQueue`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminAppointmentQueue
     * @name AdminAppointmentQueueSettleUpdate
     * @request PUT:/api/AdminAppointmentQueue/Settle
     * @secure
     */
    adminAppointmentQueueSettleUpdate: (
      data: SettleMerchantAppointmentQueueCommand,
      params: RequestParams = {},
    ) =>
      this.request<AdminAppointmentQueueSettleUpdateData, FailedResponse>({
        path: `/api/AdminAppointmentQueue/Settle`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminAppointmentQueue
     * @name AdminAppointmentQueueCancelUpdate
     * @request PUT:/api/AdminAppointmentQueue/Cancel
     * @secure
     */
    adminAppointmentQueueCancelUpdate: (
      data: CancelAppointmentQueueCommand,
      params: RequestParams = {},
    ) =>
      this.request<AdminAppointmentQueueCancelUpdateData, FailedResponse>({
        path: `/api/AdminAppointmentQueue/Cancel`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminCustomerPurchase
     * @name AdminCustomerPurchaseList
     * @request GET:/api/AdminCustomerPurchase
     * @secure
     */
    adminCustomerPurchaseList: (
      query: AdminCustomerPurchaseListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<AdminCustomerPurchaseListData, FailedResponse>({
        path: `/api/AdminCustomerPurchase`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminMerchant
     * @name AdminMerchantList
     * @request GET:/api/AdminMerchant
     * @secure
     */
    adminMerchantList: (
      query: AdminMerchantListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<AdminMerchantListData, FailedResponse>({
        path: `/api/AdminMerchant`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminMerchant
     * @name AdminMerchantVerificationList
     * @request GET:/api/AdminMerchant/Verification
     * @secure
     */
    adminMerchantVerificationList: (
      query: AdminMerchantVerificationListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<AdminMerchantVerificationListData, FailedResponse>({
        path: `/api/AdminMerchant/Verification`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminMerchant
     * @name AdminMerchantVerificationInquiryCreate
     * @request POST:/api/AdminMerchant/Verification/Inquiry
     * @secure
     */
    adminMerchantVerificationInquiryCreate: (
      data: VerificationInquiryCommand,
      params: RequestParams = {},
    ) =>
      this.request<AdminMerchantVerificationInquiryCreateData, FailedResponse>({
        path: `/api/AdminMerchant/Verification/Inquiry`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminMerchant
     * @name AdminMerchantAcceptUpdate
     * @request PUT:/api/AdminMerchant/Accept
     * @secure
     */
    adminMerchantAcceptUpdate: (
      data: AcceptMerchantVerificationCommand,
      params: RequestParams = {},
    ) =>
      this.request<AdminMerchantAcceptUpdateData, FailedResponse>({
        path: `/api/AdminMerchant/Accept`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminMerchant
     * @name AdminMerchantRejectUpdate
     * @request PUT:/api/AdminMerchant/Reject
     * @secure
     */
    adminMerchantRejectUpdate: (
      data: RejectMerchantVerificationCommand,
      params: RequestParams = {},
    ) =>
      this.request<AdminMerchantRejectUpdateData, FailedResponse>({
        path: `/api/AdminMerchant/Reject`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminMerchant
     * @name AdminMerchantSnappPayUpdate
     * @request PUT:/api/AdminMerchant/SnappPay
     * @secure
     */
    adminMerchantSnappPayUpdate: (
      data: SetMerchantSnappPayEnabledCommand,
      params: RequestParams = {},
    ) =>
      this.request<AdminMerchantSnappPayUpdateData, FailedResponse>({
        path: `/api/AdminMerchant/SnappPay`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminMerchant
     * @name AdminMerchantCustomerDepositUpdate
     * @request PUT:/api/AdminMerchant/CustomerDeposit
     * @secure
     */
    adminMerchantCustomerDepositUpdate: (
      data: SetMerchantCustomerDepositCommand,
      params: RequestParams = {},
    ) =>
      this.request<AdminMerchantCustomerDepositUpdateData, FailedResponse>({
        path: `/api/AdminMerchant/CustomerDeposit`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminMerchantFee
     * @name AdminMerchantFeeDetail
     * @request GET:/api/AdminMerchantFee/{merchantId}
     * @secure
     */
    adminMerchantFeeDetail: (
      { merchantId }: AdminMerchantFeeDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminMerchantFeeDetailData, FailedResponse>({
        path: `/api/AdminMerchantFee/${merchantId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminMerchantFee
     * @name AdminMerchantFeeUpdate
     * @request PUT:/api/AdminMerchantFee
     * @secure
     */
    adminMerchantFeeUpdate: (
      data: UpsertMerchantFeeCommand,
      params: RequestParams = {},
    ) =>
      this.request<AdminMerchantFeeUpdateData, FailedResponse>({
        path: `/api/AdminMerchantFee`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminMerchantMarkup
     * @name AdminMerchantMarkupDetail
     * @request GET:/api/AdminMerchantMarkup/{merchantId}
     * @secure
     */
    adminMerchantMarkupDetail: (
      { merchantId }: AdminMerchantMarkupDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminMerchantMarkupDetailData, FailedResponse>({
        path: `/api/AdminMerchantMarkup/${merchantId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminMerchantMarkup
     * @name AdminMerchantMarkupUpdate
     * @request PUT:/api/AdminMerchantMarkup
     * @secure
     */
    adminMerchantMarkupUpdate: (
      data: UpdateMerchantMarkupCommand,
      params: RequestParams = {},
    ) =>
      this.request<AdminMerchantMarkupUpdateData, FailedResponse>({
        path: `/api/AdminMerchantMarkup`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSmsReport
     * @name AdminSmsReportList
     * @request GET:/api/AdminSmsReport
     * @secure
     */
    adminSmsReportList: (
      query: AdminSmsReportListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<AdminSmsReportListData, FailedResponse>({
        path: `/api/AdminSmsReport`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSmsReport
     * @name AdminSmsReportAcceptUpdate
     * @request PUT:/api/AdminSmsReport/Accept
     * @secure
     */
    adminSmsReportAcceptUpdate: (
      data: AcceptSendSmsRegionRequestCommand,
      params: RequestParams = {},
    ) =>
      this.request<AdminSmsReportAcceptUpdateData, FailedResponse>({
        path: `/api/AdminSmsReport/Accept`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSmsReport
     * @name AdminSmsReportRejectUpdate
     * @request PUT:/api/AdminSmsReport/Reject
     * @secure
     */
    adminSmsReportRejectUpdate: (
      data: RejectSendSmsRegionRequestCommand,
      params: RequestParams = {},
    ) =>
      this.request<AdminSmsReportRejectUpdateData, FailedResponse>({
        path: `/api/AdminSmsReport/Reject`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSmsTemplate
     * @name AdminSmsTemplateDetail
     * @request GET:/api/AdminSmsTemplate/{id}
     * @secure
     */
    adminSmsTemplateDetail: (
      { id }: AdminSmsTemplateDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminSmsTemplateDetailData, FailedResponse>({
        path: `/api/AdminSmsTemplate/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSmsTemplate
     * @name AdminSmsTemplateList
     * @request GET:/api/AdminSmsTemplate
     * @secure
     */
    adminSmsTemplateList: (
      query: AdminSmsTemplateListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<AdminSmsTemplateListData, FailedResponse>({
        path: `/api/AdminSmsTemplate`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSmsTemplate
     * @name AdminSmsTemplateAcceptUpdate
     * @request PUT:/api/AdminSmsTemplate/Accept
     * @secure
     */
    adminSmsTemplateAcceptUpdate: (
      data: AcceptSmsTemplateCommand,
      params: RequestParams = {},
    ) =>
      this.request<AdminSmsTemplateAcceptUpdateData, FailedResponse>({
        path: `/api/AdminSmsTemplate/Accept`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSmsTemplate
     * @name AdminSmsTemplateRejectUpdate
     * @request PUT:/api/AdminSmsTemplate/Reject
     * @secure
     */
    adminSmsTemplateRejectUpdate: (
      data: RejectSmsTemplateCommand,
      params: RequestParams = {},
    ) =>
      this.request<AdminSmsTemplateRejectUpdateData, FailedResponse>({
        path: `/api/AdminSmsTemplate/Reject`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTransaction
     * @name AdminTransactionList
     * @request GET:/api/AdminTransaction
     * @secure
     */
    adminTransactionList: (
      query: AdminTransactionListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<AdminTransactionListData, FailedResponse>({
        path: `/api/AdminTransaction`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags App
     * @name AppDownloadApkList
     * @request GET:/api/App/DownloadApk
     * @secure
     */
    appDownloadApkList: (params: RequestParams = {}) =>
      this.request<AppDownloadApkListData, any>({
        path: `/api/App/DownloadApk`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppInfo
     * @name AppInfoCreate
     * @request POST:/api/AppInfo
     * @secure
     */
    appInfoCreate: (data: CreateAppInfoCommand, params: RequestParams = {}) =>
      this.request<AppInfoCreateData, any>({
        path: `/api/AppInfo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppInfo
     * @name AppInfoChangeUpdate
     * @request PUT:/api/AppInfo/Change
     * @secure
     */
    appInfoChangeUpdate: (
      data: UpdateAppInfoUserCommand,
      params: RequestParams = {},
    ) =>
      this.request<AppInfoChangeUpdateData, any>({
        path: `/api/AppInfo/Change`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Appointment
     * @name B2CAppointmentList
     * @request GET:/api/b2c/Appointment
     * @secure
     */
    b2CAppointmentList: (
      query: B2CAppointmentListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<B2CAppointmentListData, FailedResponse>({
        path: `/api/b2c/Appointment`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Appointment
     * @name B2CAppointmentCreate
     * @request POST:/api/b2c/Appointment
     * @secure
     */
    b2CAppointmentCreate: (
      data: B2CPlaceAppointmentsCommand,
      params: RequestParams = {},
    ) =>
      this.request<B2CAppointmentCreateData, FailedResponse>({
        path: `/api/b2c/Appointment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Appointment
     * @name B2CAppointmentQueueDetailsList
     * @request GET:/api/b2c/Appointment/queue/{appointmentQueueId}/details
     * @secure
     */
    b2CAppointmentQueueDetailsList: (
      { appointmentQueueId }: B2CAppointmentQueueDetailsListParams,
      params: RequestParams = {},
    ) =>
      this.request<B2CAppointmentQueueDetailsListData, FailedResponse>({
        path: `/api/b2c/Appointment/queue/${appointmentQueueId}/details`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Appointment
     * @name B2CAppointmentMyAppointmentsList
     * @request GET:/api/b2c/Appointment/my-appointments
     * @secure
     */
    b2CAppointmentMyAppointmentsList: (
      query: B2CAppointmentMyAppointmentsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<B2CAppointmentMyAppointmentsListData, FailedResponse>({
        path: `/api/b2c/Appointment/my-appointments`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Appointment
     * @name AppointmentList
     * @request GET:/api/Appointment
     * @secure
     */
    appointmentList: (
      query: AppointmentListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<AppointmentListData, FailedResponse>({
        path: `/api/Appointment`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Appointment
     * @name AppointmentCreate
     * @request POST:/api/Appointment
     * @secure
     */
    appointmentCreate: (
      data: PlaceAppointmentsCommand,
      params: RequestParams = {},
    ) =>
      this.request<AppointmentCreateData, FailedResponse>({
        path: `/api/Appointment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Appointment
     * @name AppointmentCancelUpdate
     * @request PUT:/api/Appointment/Cancel
     * @secure
     */
    appointmentCancelUpdate: (
      data: CancelAppointmentCommand,
      params: RequestParams = {},
    ) =>
      this.request<AppointmentCancelUpdateData, FailedResponse>({
        path: `/api/Appointment/Cancel`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppointmentQueue
     * @name B2CAppointmentQueuePayCreate
     * @request POST:/api/b2c/AppointmentQueue/Pay
     * @secure
     */
    b2CAppointmentQueuePayCreate: (
      data: B2CPlaceAppointmentQueueCommand,
      params: RequestParams = {},
    ) =>
      this.request<B2CAppointmentQueuePayCreateData, FailedResponse>({
        path: `/api/b2c/AppointmentQueue/Pay`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppointmentQueue
     * @name B2CAppointmentQueueSnappPayEligibilityCreate
     * @request POST:/api/b2c/AppointmentQueue/SnappPay/Eligibility
     * @secure
     */
    b2CAppointmentQueueSnappPayEligibilityCreate: (
      data: AppointmentSnappPayEligibilityCommand,
      params: RequestParams = {},
    ) =>
      this.request<
        B2CAppointmentQueueSnappPayEligibilityCreateData,
        FailedResponse
      >({
        path: `/api/b2c/AppointmentQueue/SnappPay/Eligibility`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppointmentQueue
     * @name B2CAppointmentQueueSnappPayInquiryCreate
     * @request POST:/api/b2c/AppointmentQueue/{appointmentQueueId}/SnappPay/Inquiry
     * @secure
     */
    b2CAppointmentQueueSnappPayInquiryCreate: (
      { appointmentQueueId }: B2CAppointmentQueueSnappPayInquiryCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<
        B2CAppointmentQueueSnappPayInquiryCreateData,
        FailedResponse
      >({
        path: `/api/b2c/AppointmentQueue/${appointmentQueueId}/SnappPay/Inquiry`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppointmentQueue
     * @name AppointmentQueueList
     * @request GET:/api/AppointmentQueue
     * @secure
     */
    appointmentQueueList: (
      query: AppointmentQueueListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<AppointmentQueueListData, FailedResponse>({
        path: `/api/AppointmentQueue`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppointmentQueue
     * @name AppointmentQueueByAppointmentIdList
     * @request GET:/api/AppointmentQueue/ByAppointmentId
     * @secure
     */
    appointmentQueueByAppointmentIdList: (
      query: AppointmentQueueByAppointmentIdListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<AppointmentQueueByAppointmentIdListData, FailedResponse>({
        path: `/api/AppointmentQueue/ByAppointmentId`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppointmentQueue
     * @name AppointmentQueueDetail
     * @request GET:/api/AppointmentQueue/{appointmentQueueId}
     * @secure
     */
    appointmentQueueDetail: (
      { appointmentQueueId }: AppointmentQueueDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<AppointmentQueueDetailData, FailedResponse>({
        path: `/api/AppointmentQueue/${appointmentQueueId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppointmentQueue
     * @name AppointmentQueueCancelUpdate
     * @request PUT:/api/AppointmentQueue/Cancel
     * @secure
     */
    appointmentQueueCancelUpdate: (
      data: CancelAppointmentQueueCommand,
      params: RequestParams = {},
    ) =>
      this.request<AppointmentQueueCancelUpdateData, FailedResponse>({
        path: `/api/AppointmentQueue/Cancel`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authenticate
     * @name AuthenticateCheckUserCreate
     * @request POST:/api/Authenticate/CheckUser
     * @secure
     */
    authenticateCheckUserCreate: (
      data: CheckUserCommand,
      params: RequestParams = {},
    ) =>
      this.request<AuthenticateCheckUserCreateData, any>({
        path: `/api/Authenticate/CheckUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authenticate
     * @name AuthenticateSignInCreate
     * @request POST:/api/Authenticate/SignIn
     * @secure
     */
    authenticateSignInCreate: (
      data: SignInCommand,
      params: RequestParams = {},
    ) =>
      this.request<AuthenticateSignInCreateData, any>({
        path: `/api/Authenticate/SignIn`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authenticate
     * @name AuthenticateSignInWithOtpCreate
     * @request POST:/api/Authenticate/SignInWithOtp
     * @secure
     */
    authenticateSignInWithOtpCreate: (
      data: SendOtpCodeCommand,
      params: RequestParams = {},
    ) =>
      this.request<AuthenticateSignInWithOtpCreateData, any>({
        path: `/api/Authenticate/SignInWithOtp`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authenticate
     * @name AuthenticateVerifyOtpLoginCreate
     * @request POST:/api/Authenticate/VerifyOtpLogin
     * @secure
     */
    authenticateVerifyOtpLoginCreate: (
      data: UserVerifyOtpCommand,
      params: RequestParams = {},
    ) =>
      this.request<AuthenticateVerifyOtpLoginCreateData, any>({
        path: `/api/Authenticate/VerifyOtpLogin`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authenticate
     * @name AuthenticateSignUpCreate
     * @request POST:/api/Authenticate/SignUp
     * @secure
     */
    authenticateSignUpCreate: (
      data: SignUpCommand,
      params: RequestParams = {},
    ) =>
      this.request<AuthenticateSignUpCreateData, any>({
        path: `/api/Authenticate/SignUp`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authenticate
     * @name AuthenticateVerifySignUpCreate
     * @request POST:/api/Authenticate/VerifySignUp
     * @secure
     */
    authenticateVerifySignUpCreate: (
      data: VerifySignUpCommand,
      params: RequestParams = {},
    ) =>
      this.request<AuthenticateVerifySignUpCreateData, any>({
        path: `/api/Authenticate/VerifySignUp`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authenticate
     * @name AuthenticateForgetPasswordOtpCreate
     * @request POST:/api/Authenticate/ForgetPasswordOtp
     * @secure
     */
    authenticateForgetPasswordOtpCreate: (
      data: SendOtpCodeCommand,
      params: RequestParams = {},
    ) =>
      this.request<AuthenticateForgetPasswordOtpCreateData, any>({
        path: `/api/Authenticate/ForgetPasswordOtp`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authenticate
     * @name AuthenticateVerifyOtpForgetPasswordCreate
     * @request POST:/api/Authenticate/VerifyOtpForgetPassword
     * @secure
     */
    authenticateVerifyOtpForgetPasswordCreate: (
      data: VerifyForgetPasswordOtpCommand,
      params: RequestParams = {},
    ) =>
      this.request<AuthenticateVerifyOtpForgetPasswordCreateData, any>({
        path: `/api/Authenticate/VerifyOtpForgetPassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authenticate
     * @name AuthenticateResetPasswordCreate
     * @request POST:/api/Authenticate/ResetPassword
     * @secure
     */
    authenticateResetPasswordCreate: (
      data: ResetPasswordCommand,
      params: RequestParams = {},
    ) =>
      this.request<AuthenticateResetPasswordCreateData, any>({
        path: `/api/Authenticate/ResetPassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authenticate
     * @name AuthenticateRefreshTokenCreate
     * @request POST:/api/Authenticate/RefreshToken
     * @secure
     */
    authenticateRefreshTokenCreate: (
      data: RefreshTokenCommand,
      params: RequestParams = {},
    ) =>
      this.request<AuthenticateRefreshTokenCreateData, any>({
        path: `/api/Authenticate/RefreshToken`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Balance
     * @name BalanceList
     * @request GET:/api/Balance
     * @secure
     */
    balanceList: (params: RequestParams = {}) =>
      this.request<BalanceListData, FailedResponse>({
        path: `/api/Balance`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BarberDashboard
     * @name BarberDashboardOverviewList
     * @request GET:/api/BarberDashboard/Overview
     * @secure
     */
    barberDashboardOverviewList: (
      query: BarberDashboardOverviewListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<BarberDashboardOverviewListData, FailedResponse>({
        path: `/api/BarberDashboard/Overview`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContactUs
     * @name ContactUsCreate
     * @request POST:/api/ContactUs
     * @secure
     */
    contactUsCreate: (data: AddContactUsCommand, params: RequestParams = {}) =>
      this.request<ContactUsCreateData, FailedResponse>({
        path: `/api/ContactUs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerCreate
     * @request POST:/api/Customer
     * @secure
     */
    customerCreate: (data: CreateCustomerCommand, params: RequestParams = {}) =>
      this.request<CustomerCreateData, FailedResponse>({
        path: `/api/Customer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerUpdate
     * @request PUT:/api/Customer
     * @secure
     */
    customerUpdate: (data: UpdateCustomerCommand, params: RequestParams = {}) =>
      this.request<CustomerUpdateData, FailedResponse>({
        path: `/api/Customer`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerList
     * @request GET:/api/Customer
     * @secure
     */
    customerList: (
      query: CustomerListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<CustomerListData, FailedResponse>({
        path: `/api/Customer`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerDelete
     * @request DELETE:/api/Customer
     * @secure
     */
    customerDelete: (data: DeleteCustomerCommand, params: RequestParams = {}) =>
      this.request<CustomerDeleteData, FailedResponse>({
        path: `/api/Customer`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerAddOwnerCreate
     * @request POST:/api/Customer/AddOwner
     * @secure
     */
    customerAddOwnerCreate: (
      data: AddCustomerOwnerCommand,
      params: RequestParams = {},
    ) =>
      this.request<CustomerAddOwnerCreateData, FailedResponse>({
        path: `/api/Customer/AddOwner`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerAssignOwnersCreate
     * @request POST:/api/Customer/AssignOwners
     * @secure
     */
    customerAssignOwnersCreate: (
      data: AssignCustomerOwnersCommand,
      params: RequestParams = {},
    ) =>
      this.request<CustomerAssignOwnersCreateData, FailedResponse>({
        path: `/api/Customer/AssignOwners`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerUnassignOwnersCreate
     * @request POST:/api/Customer/UnassignOwners
     * @secure
     */
    customerUnassignOwnersCreate: (
      data: UnassignCustomerOwnersCommand,
      params: RequestParams = {},
    ) =>
      this.request<CustomerUnassignOwnersCreateData, FailedResponse>({
        path: `/api/Customer/UnassignOwners`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerBulkCreate
     * @request POST:/api/Customer/Bulk
     * @secure
     */
    customerBulkCreate: (
      data: CreateCustomersCommand,
      params: RequestParams = {},
    ) =>
      this.request<CustomerBulkCreateData, FailedResponse>({
        path: `/api/Customer/Bulk`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerMobileNumberList
     * @request GET:/api/Customer/MobileNumber
     * @secure
     */
    customerMobileNumberList: (
      query: CustomerMobileNumberListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<CustomerMobileNumberListData, FailedResponse>({
        path: `/api/Customer/MobileNumber`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerInfoList
     * @request GET:/api/Customer/Info
     * @secure
     */
    customerInfoList: (
      query: CustomerInfoListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<CustomerInfoListData, FailedResponse>({
        path: `/api/Customer/Info`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerInfoDetail
     * @request GET:/api/Customer/Info/{id}
     * @secure
     */
    customerInfoDetail: (
      { id }: CustomerInfoDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<CustomerInfoDetailData, FailedResponse>({
        path: `/api/Customer/Info/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerGroupsList
     * @request GET:/api/Customer/Groups
     * @secure
     */
    customerGroupsList: (
      query: CustomerGroupsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<CustomerGroupsListData, FailedResponse>({
        path: `/api/Customer/Groups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerAuth
     * @name CustomerAuthCheckCustomerCreate
     * @request POST:/api/CustomerAuth/CheckCustomer
     * @secure
     */
    customerAuthCheckCustomerCreate: (
      data: CheckUserCommand,
      params: RequestParams = {},
    ) =>
      this.request<CustomerAuthCheckCustomerCreateData, any>({
        path: `/api/CustomerAuth/CheckCustomer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerAuth
     * @name CustomerAuthSignInCreate
     * @request POST:/api/CustomerAuth/SignIn
     * @secure
     */
    customerAuthSignInCreate: (
      data: CustomerSignInCommand,
      params: RequestParams = {},
    ) =>
      this.request<CustomerAuthSignInCreateData, any>({
        path: `/api/CustomerAuth/SignIn`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerAuth
     * @name CustomerAuthSignInWithOtpCreate
     * @request POST:/api/CustomerAuth/SignInWithOtp
     * @secure
     */
    customerAuthSignInWithOtpCreate: (
      data: CustomerSendOtpCodeCommand,
      params: RequestParams = {},
    ) =>
      this.request<CustomerAuthSignInWithOtpCreateData, any>({
        path: `/api/CustomerAuth/SignInWithOtp`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerAuth
     * @name CustomerAuthVerifyOtpLoginCreate
     * @request POST:/api/CustomerAuth/VerifyOtpLogin
     * @secure
     */
    customerAuthVerifyOtpLoginCreate: (
      data: CustomerVerifyOtpCommand,
      params: RequestParams = {},
    ) =>
      this.request<CustomerAuthVerifyOtpLoginCreateData, any>({
        path: `/api/CustomerAuth/VerifyOtpLogin`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerAuth
     * @name CustomerAuthSignUpCreate
     * @request POST:/api/CustomerAuth/SignUp
     * @secure
     */
    customerAuthSignUpCreate: (
      data: CustomerSignUpCommand,
      params: RequestParams = {},
    ) =>
      this.request<CustomerAuthSignUpCreateData, any>({
        path: `/api/CustomerAuth/SignUp`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerAuth
     * @name CustomerAuthVerifySignUpCreate
     * @request POST:/api/CustomerAuth/VerifySignUp
     * @secure
     */
    customerAuthVerifySignUpCreate: (
      data: CustomerVerifySignUpCommand,
      params: RequestParams = {},
    ) =>
      this.request<CustomerAuthVerifySignUpCreateData, any>({
        path: `/api/CustomerAuth/VerifySignUp`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerAuth
     * @name CustomerAuthForgetPasswordOtpCreate
     * @request POST:/api/CustomerAuth/ForgetPasswordOtp
     * @secure
     */
    customerAuthForgetPasswordOtpCreate: (
      data: CustomerSendOtpCodeCommand,
      params: RequestParams = {},
    ) =>
      this.request<CustomerAuthForgetPasswordOtpCreateData, any>({
        path: `/api/CustomerAuth/ForgetPasswordOtp`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerAuth
     * @name CustomerAuthVerifyOtpForgetPasswordCreate
     * @request POST:/api/CustomerAuth/VerifyOtpForgetPassword
     * @secure
     */
    customerAuthVerifyOtpForgetPasswordCreate: (
      data: CustomerVerifyForgetPasswordOtpCommand,
      params: RequestParams = {},
    ) =>
      this.request<CustomerAuthVerifyOtpForgetPasswordCreateData, any>({
        path: `/api/CustomerAuth/VerifyOtpForgetPassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerAuth
     * @name CustomerAuthResetPasswordCreate
     * @request POST:/api/CustomerAuth/ResetPassword
     * @secure
     */
    customerAuthResetPasswordCreate: (
      data: CustomerResetPasswordCommand,
      params: RequestParams = {},
    ) =>
      this.request<CustomerAuthResetPasswordCreateData, any>({
        path: `/api/CustomerAuth/ResetPassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerAuth
     * @name CustomerAuthRefreshTokenCreate
     * @request POST:/api/CustomerAuth/RefreshToken
     * @secure
     */
    customerAuthRefreshTokenCreate: (
      data: CustomerRefreshTokenCommand,
      params: RequestParams = {},
    ) =>
      this.request<CustomerAuthRefreshTokenCreateData, any>({
        path: `/api/CustomerAuth/RefreshToken`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerDiscount
     * @name CustomerDiscountList
     * @request GET:/api/Customer/{customerId}/Discount
     * @secure
     */
    customerDiscountList: (
      { customerId }: CustomerDiscountListParams,
      params: RequestParams = {},
    ) =>
      this.request<CustomerDiscountListData, FailedResponse>({
        path: `/api/Customer/${customerId}/Discount`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerGroup
     * @name CustomerGroupList
     * @request GET:/api/CustomerGroup
     * @secure
     */
    customerGroupList: (
      query: CustomerGroupListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<CustomerGroupListData, FailedResponse>({
        path: `/api/CustomerGroup`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerGroup
     * @name CustomerGroupCreate
     * @request POST:/api/CustomerGroup
     * @secure
     */
    customerGroupCreate: (
      data: CreateCustomerGroupCommand,
      params: RequestParams = {},
    ) =>
      this.request<CustomerGroupCreateData, FailedResponse>({
        path: `/api/CustomerGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerGroup
     * @name CustomerGroupDelete
     * @request DELETE:/api/CustomerGroup
     * @secure
     */
    customerGroupDelete: (
      data: DeleteCustomerGroupCommand,
      params: RequestParams = {},
    ) =>
      this.request<CustomerGroupDeleteData, FailedResponse>({
        path: `/api/CustomerGroup`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerGroup
     * @name CustomerGroupMemberCreate
     * @request POST:/api/CustomerGroup/Member
     * @secure
     */
    customerGroupMemberCreate: (
      data: AddCustomerGroupMemberCommand,
      params: RequestParams = {},
    ) =>
      this.request<CustomerGroupMemberCreateData, FailedResponse>({
        path: `/api/CustomerGroup/Member`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerGroup
     * @name CustomerGroupMemberDelete
     * @request DELETE:/api/CustomerGroup/Member
     * @secure
     */
    customerGroupMemberDelete: (
      data: RemoveCustomerMemberCommand,
      params: RequestParams = {},
    ) =>
      this.request<CustomerGroupMemberDeleteData, FailedResponse>({
        path: `/api/CustomerGroup/Member`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerGroup
     * @name CustomerGroupBulkMemberCreate
     * @request POST:/api/CustomerGroup/BulkMember
     * @secure
     */
    customerGroupBulkMemberCreate: (
      data: AddCustomersGroupMemberCommand,
      params: RequestParams = {},
    ) =>
      this.request<CustomerGroupBulkMemberCreateData, FailedResponse>({
        path: `/api/CustomerGroup/BulkMember`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerGroup
     * @name CustomerGroupMembersList
     * @request GET:/api/CustomerGroup/{customerGroupId}/Members
     * @secure
     */
    customerGroupMembersList: (
      { customerGroupId, ...query }: CustomerGroupMembersListParams,
      params: RequestParams = {},
    ) =>
      this.request<CustomerGroupMembersListData, FailedResponse>({
        path: `/api/CustomerGroup/${customerGroupId}/Members`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerGroup
     * @name CustomerGroupMembersCountList
     * @request GET:/api/CustomerGroup/{customerGroupId}/MembersCount
     * @secure
     */
    customerGroupMembersCountList: (
      { customerGroupId }: CustomerGroupMembersCountListParams,
      params: RequestParams = {},
    ) =>
      this.request<CustomerGroupMembersCountListData, FailedResponse>({
        path: `/api/CustomerGroup/${customerGroupId}/MembersCount`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerNotifier
     * @name CustomerNotifierCheckBalanceList
     * @request GET:/api/CustomerNotifier/CheckBalance
     * @secure
     */
    customerNotifierCheckBalanceList: (
      query: CustomerNotifierCheckBalanceListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<CustomerNotifierCheckBalanceListData, FailedResponse>({
        path: `/api/CustomerNotifier/CheckBalance`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerPurchase
     * @name CustomerPurchaseList
     * @request GET:/api/CustomerPurchase
     * @secure
     */
    customerPurchaseList: (
      query: CustomerPurchaseListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<CustomerPurchaseListData, FailedResponse>({
        path: `/api/CustomerPurchase`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerPurchase
     * @name CustomerPurchaseCreate
     * @request POST:/api/CustomerPurchase
     * @secure
     */
    customerPurchaseCreate: (
      data: CreateCustomerPurchaseCommand,
      params: RequestParams = {},
    ) =>
      this.request<CustomerPurchaseCreateData, FailedResponse>({
        path: `/api/CustomerPurchase`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerPurchase
     * @name CustomerPurchaseDetail
     * @request GET:/api/CustomerPurchase/{purchaseId}
     * @secure
     */
    customerPurchaseDetail: (
      { purchaseId }: CustomerPurchaseDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<CustomerPurchaseDetailData, FailedResponse>({
        path: `/api/CustomerPurchase/${purchaseId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerPurchase
     * @name CustomerPurchaseReviewInvitationList
     * @request GET:/api/CustomerPurchase/{purchaseId}/ReviewInvitation
     * @secure
     */
    customerPurchaseReviewInvitationList: (
      { purchaseId }: CustomerPurchaseReviewInvitationListParams,
      params: RequestParams = {},
    ) =>
      this.request<CustomerPurchaseReviewInvitationListData, FailedResponse>({
        path: `/api/CustomerPurchase/${purchaseId}/ReviewInvitation`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerPurchase
     * @name CustomerPurchaseSnappPayEligibilityCreate
     * @request POST:/api/CustomerPurchase/SnappPay/Eligibility
     * @secure
     */
    customerPurchaseSnappPayEligibilityCreate: (
      data: SnappPayEligibilityCommand,
      params: RequestParams = {},
    ) =>
      this.request<
        CustomerPurchaseSnappPayEligibilityCreateData,
        FailedResponse
      >({
        path: `/api/CustomerPurchase/SnappPay/Eligibility`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerPurchase
     * @name CustomerPurchasePaymentLinkResendCreate
     * @request POST:/api/CustomerPurchase/{purchaseId}/PaymentLink/Resend
     * @secure
     */
    customerPurchasePaymentLinkResendCreate: (
      { purchaseId }: CustomerPurchasePaymentLinkResendCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<CustomerPurchasePaymentLinkResendCreateData, FailedResponse>(
        {
          path: `/api/CustomerPurchase/${purchaseId}/PaymentLink/Resend`,
          method: "POST",
          secure: true,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags CustomerPurchase
     * @name CustomerPurchaseRetryCreate
     * @request POST:/api/CustomerPurchase/{purchaseId}/Retry
     * @secure
     */
    customerPurchaseRetryCreate: (
      { purchaseId }: CustomerPurchaseRetryCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<CustomerPurchaseRetryCreateData, FailedResponse>({
        path: `/api/CustomerPurchase/${purchaseId}/Retry`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerPurchase
     * @name CustomerPurchaseSnappPayCancelCreate
     * @request POST:/api/CustomerPurchase/SnappPay/Cancel
     * @secure
     */
    customerPurchaseSnappPayCancelCreate: (
      data: CancelSnappPayPaymentCommand,
      params: RequestParams = {},
    ) =>
      this.request<CustomerPurchaseSnappPayCancelCreateData, FailedResponse>({
        path: `/api/CustomerPurchase/SnappPay/Cancel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerReviewInvitation
     * @name B2CReviewInvitationPreviewList
     * @request GET:/api/b2c/ReviewInvitation/{token}/Preview
     * @secure
     */
    b2CReviewInvitationPreviewList: (
      { token, ...query }: B2CReviewInvitationPreviewListParams,
      params: RequestParams = {},
    ) =>
      this.request<B2CReviewInvitationPreviewListData, FailedResponse>({
        path: `/api/b2c/ReviewInvitation/${token}/Preview`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerReviewInvitation
     * @name B2CReviewInvitationDetail
     * @request GET:/api/b2c/ReviewInvitation/{token}
     * @secure
     */
    b2CReviewInvitationDetail: (
      { token, ...query }: B2CReviewInvitationDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<B2CReviewInvitationDetailData, FailedResponse>({
        path: `/api/b2c/ReviewInvitation/${token}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerReviewInvitation
     * @name B2CReviewInvitationReviewCreate
     * @request POST:/api/b2c/ReviewInvitation/{token}/Review
     * @secure
     */
    b2CReviewInvitationReviewCreate: (
      { token, ...query }: B2CReviewInvitationReviewCreateParams,
      data: SubmitCustomerReviewCommand,
      params: RequestParams = {},
    ) =>
      this.request<B2CReviewInvitationReviewCreateData, FailedResponse>({
        path: `/api/b2c/ReviewInvitation/${token}/Review`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Discount
     * @name B2CDiscountValidateList
     * @request GET:/api/b2c/Discount/Validate
     * @secure
     */
    b2CDiscountValidateList: (
      query: B2CDiscountValidateListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<B2CDiscountValidateListData, FailedResponse>({
        path: `/api/b2c/Discount/Validate`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Discount
     * @name DiscountValidateList
     * @request GET:/api/Discount/Validate
     * @secure
     */
    discountValidateList: (
      query: DiscountValidateListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<DiscountValidateListData, FailedResponse>({
        path: `/api/Discount/Validate`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Discount
     * @name DiscountCustomerGroupCreate
     * @request POST:/api/Discount/CustomerGroup
     * @secure
     */
    discountCustomerGroupCreate: (
      data: CreateCustomerGroupDiscountCommand,
      params: RequestParams = {},
    ) =>
      this.request<DiscountCustomerGroupCreateData, FailedResponse>({
        path: `/api/Discount/CustomerGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Discount
     * @name DiscountCustomerGroupCalculateSmsAmountCreate
     * @request POST:/api/Discount/CustomerGroup/CalculateSmsAmount
     * @secure
     */
    discountCustomerGroupCalculateSmsAmountCreate: (
      data: CalculateCustomerGroupDiscountSmsAmountCommand,
      params: RequestParams = {},
    ) =>
      this.request<
        DiscountCustomerGroupCalculateSmsAmountCreateData,
        FailedResponse
      >({
        path: `/api/Discount/CustomerGroup/CalculateSmsAmount`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Discount
     * @name DiscountGroupCreate
     * @request POST:/api/Discount/Group
     * @secure
     */
    discountGroupCreate: (
      data: CreateDiscountGroupCommand,
      params: RequestParams = {},
    ) =>
      this.request<DiscountGroupCreateData, FailedResponse>({
        path: `/api/Discount/Group`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Discount
     * @name DiscountGroupCalculateSmsAmountCreate
     * @request POST:/api/Discount/Group/CalculateSmsAmount
     * @secure
     */
    discountGroupCalculateSmsAmountCreate: (
      data: CalculateGroupDiscountSmsAmountCommand,
      params: RequestParams = {},
    ) =>
      this.request<DiscountGroupCalculateSmsAmountCreateData, FailedResponse>({
        path: `/api/Discount/Group/CalculateSmsAmount`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Discount
     * @name DiscountDetail
     * @request GET:/api/Discount/{code}
     * @secure
     */
    discountDetail: (
      { code }: DiscountDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<DiscountDetailData, FailedResponse>({
        path: `/api/Discount/${code}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiscountGroup
     * @name DiscountGroupList
     * @request GET:/api/DiscountGroup
     * @secure
     */
    discountGroupList: (params: RequestParams = {}) =>
      this.request<DiscountGroupListData, FailedResponse>({
        path: `/api/DiscountGroup`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiscountGroup
     * @name DiscountGroupCountDetail
     * @request GET:/api/DiscountGroup/Count/{id}
     * @secure
     */
    discountGroupCountDetail: (
      { id }: DiscountGroupCountDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<DiscountGroupCountDetailData, FailedResponse>({
        path: `/api/DiscountGroup/Count/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name FileList
     * @request GET:/api/File
     * @secure
     */
    fileList: (query: FileListParams = {}, params: RequestParams = {}) =>
      this.request<FileListData, FailedResponse>({
        path: `/api/File`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Merchant
     * @name B2CMerchantMarkupDetail
     * @request GET:/api/b2c/Merchant/Markup/{merchantId}
     * @secure
     */
    b2CMerchantMarkupDetail: (
      { merchantId }: B2CMerchantMarkupDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<B2CMerchantMarkupDetailData, FailedResponse>({
        path: `/api/b2c/Merchant/Markup/${merchantId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Merchant
     * @name B2CMerchantList
     * @request GET:/api/b2c/Merchant
     * @secure
     */
    b2CMerchantList: (
      query: B2CMerchantListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<B2CMerchantListData, FailedResponse>({
        path: `/api/b2c/Merchant`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Merchant
     * @name B2CMerchantTemplateUpdate
     * @request PUT:/api/b2c/Merchant/Template
     * @secure
     */
    b2CMerchantTemplateUpdate: (
      data: UpdateMerchantTemplateCommand,
      params: RequestParams = {},
    ) =>
      this.request<B2CMerchantTemplateUpdateData, FailedResponse>({
        path: `/api/b2c/Merchant/Template`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Merchant
     * @name MerchantList
     * @request GET:/api/Merchant
     * @secure
     */
    merchantList: (params: RequestParams = {}) =>
      this.request<MerchantListData, FailedResponse>({
        path: `/api/Merchant`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Merchant
     * @name MerchantUpdate
     * @request PUT:/api/Merchant
     * @secure
     */
    merchantUpdate: (
      data: UpdateMerchantInfoCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantUpdateData, FailedResponse>({
        path: `/api/Merchant`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Merchant
     * @name MerchantAddressUpdate
     * @request PUT:/api/Merchant/Address
     * @secure
     */
    merchantAddressUpdate: (
      data: UpdateMerchantAddressCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantAddressUpdateData, FailedResponse>({
        path: `/api/Merchant/Address`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Merchant
     * @name MerchantBusinessUpdate
     * @request PUT:/api/Merchant/Business
     * @secure
     */
    merchantBusinessUpdate: (
      data: UpdateMerchantBusinessCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantBusinessUpdateData, FailedResponse>({
        path: `/api/Merchant/Business`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Merchant
     * @name MerchantSocialMediaUpdate
     * @request PUT:/api/Merchant/SocialMedia
     * @secure
     */
    merchantSocialMediaUpdate: (
      data: UpdateMerchantSocialMediaCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantSocialMediaUpdateData, FailedResponse>({
        path: `/api/Merchant/SocialMedia`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Merchant
     * @name MerchantCustomerNotifierList
     * @request GET:/api/Merchant/CustomerNotifier
     * @secure
     */
    merchantCustomerNotifierList: (params: RequestParams = {}) =>
      this.request<MerchantCustomerNotifierListData, FailedResponse>({
        path: `/api/Merchant/CustomerNotifier`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Merchant
     * @name MerchantCustomerNotifierUpdate
     * @request PUT:/api/Merchant/CustomerNotifier
     * @secure
     */
    merchantCustomerNotifierUpdate: (
      data: MerchantCustomerNotifierCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantCustomerNotifierUpdateData, FailedResponse>({
        path: `/api/Merchant/CustomerNotifier`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Merchant
     * @name MerchantCustomersCountList
     * @request GET:/api/Merchant/CustomersCount
     * @secure
     */
    merchantCustomersCountList: (params: RequestParams = {}) =>
      this.request<MerchantCustomersCountListData, FailedResponse>({
        path: `/api/Merchant/CustomersCount`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Merchant
     * @name MerchantReferralsList
     * @request GET:/api/Merchant/Referrals
     * @secure
     */
    merchantReferralsList: (params: RequestParams = {}) =>
      this.request<MerchantReferralsListData, FailedResponse>({
        path: `/api/Merchant/Referrals`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Merchant
     * @name MerchantLogoUpdate
     * @request PUT:/api/Merchant/Logo
     * @secure
     */
    merchantLogoUpdate: (
      data: MerchantLogoUpdatePayload,
      params: RequestParams = {},
    ) =>
      this.request<MerchantLogoUpdateData, FailedResponse>({
        path: `/api/Merchant/Logo`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Merchant
     * @name MerchantCoverUpdate
     * @request PUT:/api/Merchant/Cover
     * @secure
     */
    merchantCoverUpdate: (
      data: MerchantCoverUpdatePayload,
      params: RequestParams = {},
    ) =>
      this.request<MerchantCoverUpdateData, FailedResponse>({
        path: `/api/Merchant/Cover`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantDashboard
     * @name MerchantDashboardOverviewList
     * @request GET:/api/MerchantDashboard/Overview
     * @secure
     */
    merchantDashboardOverviewList: (
      query: MerchantDashboardOverviewListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<MerchantDashboardOverviewListData, FailedResponse>({
        path: `/api/MerchantDashboard/Overview`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantDashboard
     * @name MerchantDashboardSummaryList
     * @request GET:/api/MerchantDashboard/Summary
     * @secure
     */
    merchantDashboardSummaryList: (
      query: MerchantDashboardSummaryListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<MerchantDashboardSummaryListData, FailedResponse>({
        path: `/api/MerchantDashboard/Summary`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantDashboard
     * @name MerchantDashboardBarbersList
     * @request GET:/api/MerchantDashboard/Barbers
     * @secure
     */
    merchantDashboardBarbersList: (
      query: MerchantDashboardBarbersListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<MerchantDashboardBarbersListData, FailedResponse>({
        path: `/api/MerchantDashboard/Barbers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantDashboard
     * @name MerchantDashboardServicesList
     * @request GET:/api/MerchantDashboard/Services
     * @secure
     */
    merchantDashboardServicesList: (
      query: MerchantDashboardServicesListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<MerchantDashboardServicesListData, FailedResponse>({
        path: `/api/MerchantDashboard/Services`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantGallery
     * @name MerchantGalleryList
     * @request GET:/api/MerchantGallery
     * @secure
     */
    merchantGalleryList: (params: RequestParams = {}) =>
      this.request<MerchantGalleryListData, FailedResponse>({
        path: `/api/MerchantGallery`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantGallery
     * @name MerchantGalleryCreate
     * @request POST:/api/MerchantGallery
     * @secure
     */
    merchantGalleryCreate: (
      data: MerchantGalleryCreatePayload,
      params: RequestParams = {},
    ) =>
      this.request<MerchantGalleryCreateData, FailedResponse>({
        path: `/api/MerchantGallery`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantGallery
     * @name MerchantGalleryDelete
     * @request DELETE:/api/MerchantGallery
     * @secure
     */
    merchantGalleryDelete: (
      query: MerchantGalleryDeleteParams = {},
      params: RequestParams = {},
    ) =>
      this.request<MerchantGalleryDeleteData, FailedResponse>({
        path: `/api/MerchantGallery`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantGallery
     * @name MerchantGalleryDefaultUpdate
     * @request PUT:/api/MerchantGallery/Default
     * @secure
     */
    merchantGalleryDefaultUpdate: (
      data: SetMerchantGalleryDefaultCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantGalleryDefaultUpdateData, FailedResponse>({
        path: `/api/MerchantGallery/Default`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantGallery
     * @name MerchantGalleryCaptionUpdate
     * @request PUT:/api/MerchantGallery/Caption
     * @secure
     */
    merchantGalleryCaptionUpdate: (
      data: UpdateMerchantGalleryCaptionCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantGalleryCaptionUpdateData, FailedResponse>({
        path: `/api/MerchantGallery/Caption`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantReview
     * @name MerchantReviewList
     * @request GET:/api/MerchantReview
     * @secure
     */
    merchantReviewList: (
      query: MerchantReviewListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<MerchantReviewListData, FailedResponse>({
        path: `/api/MerchantReview`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantReview
     * @name MerchantReviewDetail
     * @request GET:/api/MerchantReview/{reviewId}
     * @secure
     */
    merchantReviewDetail: (
      { reviewId }: MerchantReviewDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<MerchantReviewDetailData, FailedResponse>({
        path: `/api/MerchantReview/${reviewId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantReview
     * @name MerchantReviewModerationCreate
     * @request POST:/api/MerchantReview/{reviewId}/Moderation
     * @secure
     */
    merchantReviewModerationCreate: (
      { reviewId }: MerchantReviewModerationCreateParams,
      data: ModerateReviewCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantReviewModerationCreateData, FailedResponse>({
        path: `/api/MerchantReview/${reviewId}/Moderation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantReview
     * @name MerchantReviewReplyUpdate
     * @request PUT:/api/MerchantReview/{reviewId}/Reply
     * @secure
     */
    merchantReviewReplyUpdate: (
      { reviewId }: MerchantReviewReplyUpdateParams,
      data: SaveReviewReplyCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantReviewReplyUpdateData, FailedResponse>({
        path: `/api/MerchantReview/${reviewId}/Reply`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantReview
     * @name MerchantReviewVisibilityCreate
     * @request POST:/api/MerchantReview/{reviewId}/Visibility
     * @secure
     */
    merchantReviewVisibilityCreate: (
      { reviewId }: MerchantReviewVisibilityCreateParams,
      data: ChangeReviewVisibilityCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantReviewVisibilityCreateData, FailedResponse>({
        path: `/api/MerchantReview/${reviewId}/Visibility`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantService
     * @name MerchantServiceDetail
     * @request GET:/api/MerchantService/{id}
     * @secure
     */
    merchantServiceDetail: (
      { id }: MerchantServiceDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<MerchantServiceDetailData, FailedResponse>({
        path: `/api/MerchantService/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantService
     * @name MerchantServiceCreate
     * @request POST:/api/MerchantService
     * @secure
     */
    merchantServiceCreate: (
      data: CreateMerchantServiceCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantServiceCreateData, FailedResponse>({
        path: `/api/MerchantService`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantService
     * @name MerchantServiceUpdate
     * @request PUT:/api/MerchantService
     * @secure
     */
    merchantServiceUpdate: (
      data: UpdateMerchantServiceCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantServiceUpdateData, FailedResponse>({
        path: `/api/MerchantService`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantService
     * @name MerchantServiceOrderUpdate
     * @request PUT:/api/MerchantService/Order
     * @secure
     */
    merchantServiceOrderUpdate: (
      data: ReorderMerchantServicesCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantServiceOrderUpdateData, FailedResponse>({
        path: `/api/MerchantService/Order`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantServiceCategory
     * @name MerchantServiceCategoryList
     * @request GET:/api/MerchantServiceCategory
     * @secure
     */
    merchantServiceCategoryList: (params: RequestParams = {}) =>
      this.request<MerchantServiceCategoryListData, FailedResponse>({
        path: `/api/MerchantServiceCategory`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantServiceCategory
     * @name MerchantServiceCategoryCreate
     * @request POST:/api/MerchantServiceCategory
     * @secure
     */
    merchantServiceCategoryCreate: (
      data: CreateMerchantServiceCategoryCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantServiceCategoryCreateData, FailedResponse>({
        path: `/api/MerchantServiceCategory`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantServiceCategory
     * @name MerchantServiceCategoryUpdate
     * @request PUT:/api/MerchantServiceCategory
     * @secure
     */
    merchantServiceCategoryUpdate: (
      data: UpdateMerchantServiceCategoryCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantServiceCategoryUpdateData, FailedResponse>({
        path: `/api/MerchantServiceCategory`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantServiceCategory
     * @name MerchantServiceCategoryOrderUpdate
     * @request PUT:/api/MerchantServiceCategory/Order
     * @secure
     */
    merchantServiceCategoryOrderUpdate: (
      data: ReorderMerchantServiceCategoriesCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantServiceCategoryOrderUpdateData, FailedResponse>({
        path: `/api/MerchantServiceCategory/Order`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantType
     * @name MerchantTypeList
     * @request GET:/api/MerchantType
     * @secure
     */
    merchantTypeList: (params: RequestParams = {}) =>
      this.request<MerchantTypeListData, FailedResponse>({
        path: `/api/MerchantType`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantUser
     * @name MerchantUserGetByMobileNumberList
     * @request GET:/api/MerchantUser/GetByMobileNumber
     * @secure
     */
    merchantUserGetByMobileNumberList: (
      query: MerchantUserGetByMobileNumberListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<MerchantUserGetByMobileNumberListData, FailedResponse>({
        path: `/api/MerchantUser/GetByMobileNumber`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantUser
     * @name MerchantUserList
     * @request GET:/api/MerchantUser
     * @secure
     */
    merchantUserList: (params: RequestParams = {}) =>
      this.request<MerchantUserListData, FailedResponse>({
        path: `/api/MerchantUser`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantUser
     * @name MerchantUserCreate
     * @request POST:/api/MerchantUser
     * @secure
     */
    merchantUserCreate: (
      data: MerchantUserCreatePayload,
      params: RequestParams = {},
    ) =>
      this.request<MerchantUserCreateData, FailedResponse>({
        path: `/api/MerchantUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantUser
     * @name MerchantUserUpdate
     * @request PUT:/api/MerchantUser
     * @secure
     */
    merchantUserUpdate: (
      data: MerchantUserUpdatePayload,
      params: RequestParams = {},
    ) =>
      this.request<MerchantUserUpdateData, FailedResponse>({
        path: `/api/MerchantUser`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantUser
     * @name MerchantUserDetail
     * @request GET:/api/MerchantUser/{id}
     * @secure
     */
    merchantUserDetail: (
      { id }: MerchantUserDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<MerchantUserDetailData, FailedResponse>({
        path: `/api/MerchantUser/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantUser
     * @name MerchantUserServiceUpdate
     * @request PUT:/api/MerchantUser/Service
     * @secure
     */
    merchantUserServiceUpdate: (
      data: UpdateMerchantUserServicesCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantUserServiceUpdateData, FailedResponse>({
        path: `/api/MerchantUser/Service`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantUser
     * @name MerchantUserOrderUpdate
     * @request PUT:/api/MerchantUser/Order
     * @secure
     */
    merchantUserOrderUpdate: (
      data: ReorderMerchantUsersCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantUserOrderUpdateData, FailedResponse>({
        path: `/api/MerchantUser/Order`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantUser
     * @name MerchantUserPortfolioList
     * @request GET:/api/MerchantUser/{id}/Portfolio
     * @secure
     */
    merchantUserPortfolioList: (
      { id }: MerchantUserPortfolioListParams,
      params: RequestParams = {},
    ) =>
      this.request<MerchantUserPortfolioListData, FailedResponse>({
        path: `/api/MerchantUser/${id}/Portfolio`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantUser
     * @name MerchantUserPortfolioImageCreate
     * @request POST:/api/MerchantUser/Portfolio/Image
     * @secure
     */
    merchantUserPortfolioImageCreate: (
      data: MerchantUserPortfolioImageCreatePayload,
      params: RequestParams = {},
    ) =>
      this.request<MerchantUserPortfolioImageCreateData, FailedResponse>({
        path: `/api/MerchantUser/Portfolio/Image`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantUser
     * @name MerchantUserPortfolioUpdate
     * @request PUT:/api/MerchantUser/Portfolio
     * @secure
     */
    merchantUserPortfolioUpdate: (
      data: UpdateMerchantUserPortfolioCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantUserPortfolioUpdateData, FailedResponse>({
        path: `/api/MerchantUser/Portfolio`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantUserSettlement
     * @name MerchantUserSettlementPayableSummaryList
     * @request GET:/api/MerchantUserSettlement/Payable/Summary
     * @secure
     */
    merchantUserSettlementPayableSummaryList: (
      query: MerchantUserSettlementPayableSummaryListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        MerchantUserSettlementPayableSummaryListData,
        FailedResponse
      >({
        path: `/api/MerchantUserSettlement/Payable/Summary`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantUserSettlement
     * @name MerchantUserSettlementPayableList
     * @request GET:/api/MerchantUserSettlement/Payable
     * @secure
     */
    merchantUserSettlementPayableList: (
      query: MerchantUserSettlementPayableListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<MerchantUserSettlementPayableListData, FailedResponse>({
        path: `/api/MerchantUserSettlement/Payable`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantUserSettlement
     * @name MerchantUserSettlementCreate
     * @request POST:/api/MerchantUserSettlement
     * @secure
     */
    merchantUserSettlementCreate: (
      data: CreateMerchantUserSettlementCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantUserSettlementCreateData, FailedResponse>({
        path: `/api/MerchantUserSettlement`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantUserSettlement
     * @name MerchantUserSettlementList
     * @request GET:/api/MerchantUserSettlement
     * @secure
     */
    merchantUserSettlementList: (
      query: MerchantUserSettlementListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<MerchantUserSettlementListData, FailedResponse>({
        path: `/api/MerchantUserSettlement`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantUserSettlement
     * @name MerchantUserSettlementDetail
     * @request GET:/api/MerchantUserSettlement/{settlementId}
     * @secure
     */
    merchantUserSettlementDetail: (
      { settlementId }: MerchantUserSettlementDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<MerchantUserSettlementDetailData, FailedResponse>({
        path: `/api/MerchantUserSettlement/${settlementId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantUserSettlement
     * @name MerchantUserSettlementCancelCreate
     * @request POST:/api/MerchantUserSettlement/{settlementId}/Cancel
     * @secure
     */
    merchantUserSettlementCancelCreate: (
      { settlementId }: MerchantUserSettlementCancelCreateParams,
      data: CancelMerchantUserSettlementCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantUserSettlementCancelCreateData, FailedResponse>({
        path: `/api/MerchantUserSettlement/${settlementId}/Cancel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantVerification
     * @name MerchantVerificationList
     * @request GET:/api/MerchantVerification
     * @secure
     */
    merchantVerificationList: (params: RequestParams = {}) =>
      this.request<MerchantVerificationListData, FailedResponse>({
        path: `/api/MerchantVerification`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantVerification
     * @name MerchantVerificationNationalCardImageUpdate
     * @request PUT:/api/MerchantVerification/NationalCardImage
     * @secure
     */
    merchantVerificationNationalCardImageUpdate: (
      data: MerchantVerificationNationalCardImageUpdatePayload,
      params: RequestParams = {},
    ) =>
      this.request<
        MerchantVerificationNationalCardImageUpdateData,
        FailedResponse
      >({
        path: `/api/MerchantVerification/NationalCardImage`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantVerification
     * @name MerchantVerificationNationalCodeUpdate
     * @request PUT:/api/MerchantVerification/NationalCode
     * @secure
     */
    merchantVerificationNationalCodeUpdate: (
      data: UpdateMerchantNationalCodeCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantVerificationNationalCodeUpdateData, FailedResponse>({
        path: `/api/MerchantVerification/NationalCode`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantWorkSchedule
     * @name MerchantWorkScheduleList
     * @request GET:/api/MerchantWorkSchedule
     * @secure
     */
    merchantWorkScheduleList: (params: RequestParams = {}) =>
      this.request<MerchantWorkScheduleListData, FailedResponse>({
        path: `/api/MerchantWorkSchedule`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MerchantWorkSchedule
     * @name MerchantWorkScheduleCreate
     * @request POST:/api/MerchantWorkSchedule
     * @secure
     */
    merchantWorkScheduleCreate: (
      data: MerchantWorkScheduleCommand,
      params: RequestParams = {},
    ) =>
      this.request<MerchantWorkScheduleCreateData, FailedResponse>({
        path: `/api/MerchantWorkSchedule`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MyReviews
     * @name B2CMeReviewsDetail
     * @request GET:/api/b2c/Me/Reviews/{reviewPublicId}
     * @secure
     */
    b2CMeReviewsDetail: (
      { reviewPublicId }: B2CMeReviewsDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<B2CMeReviewsDetailData, FailedResponse>({
        path: `/api/b2c/Me/Reviews/${reviewPublicId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MyReviews
     * @name B2CMeReviewsConsentPartialUpdate
     * @request PATCH:/api/b2c/Me/Reviews/{reviewPublicId}/Consent
     * @secure
     */
    b2CMeReviewsConsentPartialUpdate: (
      { reviewPublicId }: B2CMeReviewsConsentPartialUpdateParams,
      data: WithdrawReviewConsentCommand,
      params: RequestParams = {},
    ) =>
      this.request<B2CMeReviewsConsentPartialUpdateData, FailedResponse>({
        path: `/api/b2c/Me/Reviews/${reviewPublicId}/Consent`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotifyMessage
     * @name NotifyMessageList
     * @request GET:/api/NotifyMessage
     * @secure
     */
    notifyMessageList: (
      query: NotifyMessageListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<NotifyMessageListData, FailedResponse>({
        path: `/api/NotifyMessage`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotifyMessage
     * @name NotifyMessageUpdate
     * @request PUT:/api/NotifyMessage
     * @secure
     */
    notifyMessageUpdate: (
      data: OpenNotifyMessageCommand,
      params: RequestParams = {},
    ) =>
      this.request<NotifyMessageUpdateData, FailedResponse>({
        path: `/api/NotifyMessage`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlaceHolder
     * @name PlaceHolderList
     * @request GET:/api/PlaceHolder
     * @secure
     */
    placeHolderList: (params: RequestParams = {}) =>
      this.request<PlaceHolderListData, FailedResponse>({
        path: `/api/PlaceHolder`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicReviews
     * @name B2CReviewsList
     * @request GET:/api/b2c/Reviews
     * @secure
     */
    b2CReviewsList: (
      query: B2CReviewsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<B2CReviewsListData, FailedResponse>({
        path: `/api/b2c/Reviews`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicReviews
     * @name B2CReviewsSummaryList
     * @request GET:/api/b2c/Reviews/Summary
     * @secure
     */
    b2CReviewsSummaryList: (
      query: B2CReviewsSummaryListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<B2CReviewsSummaryListData, FailedResponse>({
        path: `/api/b2c/Reviews/Summary`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicReviews
     * @name B2CProfessionalRatingsSummaryCreate
     * @request POST:/api/b2c/ProfessionalRatings/Summary
     * @secure
     */
    b2CProfessionalRatingsSummaryCreate: (
      data: ProfessionalRatingSummaryRequest,
      params: RequestParams = {},
    ) =>
      this.request<B2CProfessionalRatingsSummaryCreateData, FailedResponse>({
        path: `/api/b2c/ProfessionalRatings/Summary`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PurchasePayment
     * @name PublicPurchasePaymentDetail
     * @request GET:/api/public/PurchasePayment/{transactionId}
     * @secure
     */
    publicPurchasePaymentDetail: (
      { transactionId }: PublicPurchasePaymentDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<PublicPurchasePaymentDetailData, FailedResponse>({
        path: `/api/public/PurchasePayment/${transactionId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PurchasePayment
     * @name PublicPurchasePaymentConfirmCreate
     * @request POST:/api/public/PurchasePayment/{transactionId}/Confirm
     * @secure
     */
    publicPurchasePaymentConfirmCreate: (
      { transactionId }: PublicPurchasePaymentConfirmCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<PublicPurchasePaymentConfirmCreateData, FailedResponse>({
        path: `/api/public/PurchasePayment/${transactionId}/Confirm`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PurchasePayment
     * @name PublicPurchasePaymentInquiryCreate
     * @request POST:/api/public/PurchasePayment/{transactionId}/Inquiry
     * @secure
     */
    publicPurchasePaymentInquiryCreate: (
      { transactionId }: PublicPurchasePaymentInquiryCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<PublicPurchasePaymentInquiryCreateData, FailedResponse>({
        path: `/api/public/PurchasePayment/${transactionId}/Inquiry`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Referral
     * @name ReferralValidateList
     * @request GET:/api/Referral/Validate
     * @secure
     */
    referralValidateList: (
      query: ReferralValidateListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<ReferralValidateListData, any>({
        path: `/api/Referral/Validate`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Region
     * @name RegionList
     * @request GET:/api/Region
     * @secure
     */
    regionList: (query: RegionListParams = {}, params: RequestParams = {}) =>
      this.request<RegionListData, FailedResponse>({
        path: `/api/Region`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReviewInvitation
     * @name ReviewInvitationCapabilitiesList
     * @request GET:/api/ReviewInvitation/Capabilities
     * @secure
     */
    reviewInvitationCapabilitiesList: (params: RequestParams = {}) =>
      this.request<ReviewInvitationCapabilitiesListData, FailedResponse>({
        path: `/api/ReviewInvitation/Capabilities`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReviewInvitation
     * @name ReviewInvitationPreviewCreate
     * @request POST:/api/ReviewInvitation/Preview
     * @secure
     */
    reviewInvitationPreviewCreate: (
      data: ReviewInvitationPreviewRequest,
      params: RequestParams = {},
    ) =>
      this.request<ReviewInvitationPreviewCreateData, FailedResponse>({
        path: `/api/ReviewInvitation/Preview`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReviewInvitation
     * @name ReviewInvitationRequestsDetail
     * @request GET:/api/ReviewInvitation/Requests/{requestId}
     * @secure
     */
    reviewInvitationRequestsDetail: (
      { requestId }: ReviewInvitationRequestsDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<ReviewInvitationRequestsDetailData, FailedResponse>({
        path: `/api/ReviewInvitation/Requests/${requestId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReviewInvitation
     * @name ReviewInvitationRetryCreate
     * @request POST:/api/ReviewInvitation/{invitationId}/Retry
     * @secure
     */
    reviewInvitationRetryCreate: (
      { invitationId }: ReviewInvitationRetryCreateParams,
      data: RetryReviewInvitationCommand,
      params: RequestParams = {},
    ) =>
      this.request<ReviewInvitationRetryCreateData, FailedResponse>({
        path: `/api/ReviewInvitation/${invitationId}/Retry`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServicePrice
     * @name ServicePriceList
     * @request GET:/api/ServicePrice
     * @secure
     */
    servicePriceList: (params: RequestParams = {}) =>
      this.request<ServicePriceListData, FailedResponse>({
        path: `/api/ServicePrice`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SmartAudience
     * @name SmartAudienceList
     * @request GET:/api/SmartAudience
     * @secure
     */
    smartAudienceList: (
      query: SmartAudienceListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<SmartAudienceListData, FailedResponse>({
        path: `/api/SmartAudience`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SmartAudience
     * @name SmartAudienceCustomersList
     * @request GET:/api/SmartAudience/{audienceKey}/Customers
     * @secure
     */
    smartAudienceCustomersList: (
      { audienceKey, ...query }: SmartAudienceCustomersListParams,
      params: RequestParams = {},
    ) =>
      this.request<SmartAudienceCustomersListData, FailedResponse>({
        path: `/api/SmartAudience/${audienceKey}/Customers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SmartAudience
     * @name SmartAudienceTemplatesList
     * @request GET:/api/SmartAudience/{audienceKey}/Templates
     * @secure
     */
    smartAudienceTemplatesList: (
      { audienceKey }: SmartAudienceTemplatesListParams,
      params: RequestParams = {},
    ) =>
      this.request<SmartAudienceTemplatesListData, FailedResponse>({
        path: `/api/SmartAudience/${audienceKey}/Templates`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sms
     * @name SmsCalculateRegionSmsAmountCreate
     * @request POST:/api/Sms/CalculateRegionSmsAmount
     * @secure
     */
    smsCalculateRegionSmsAmountCreate: (
      data: CalculateRegionSmsAmountCommand,
      params: RequestParams = {},
    ) =>
      this.request<SmsCalculateRegionSmsAmountCreateData, FailedResponse>({
        path: `/api/Sms/CalculateRegionSmsAmount`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sms
     * @name SmsSendRegionRequestCreate
     * @request POST:/api/Sms/SendRegionRequest
     * @secure
     */
    smsSendRegionRequestCreate: (
      data: SendSmsRegionRequest,
      params: RequestParams = {},
    ) =>
      this.request<SmsSendRegionRequestCreateData, FailedResponse>({
        path: `/api/Sms/SendRegionRequest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sms
     * @name SmsSendAreaRequestCreate
     * @request POST:/api/Sms/SendAreaRequest
     * @secure
     */
    smsSendAreaRequestCreate: (
      data: SendSmsRegionRequest,
      params: RequestParams = {},
    ) =>
      this.request<SmsSendAreaRequestCreateData, FailedResponse>({
        path: `/api/Sms/SendAreaRequest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sms
     * @name SmsCalculateSmsAmountCreate
     * @request POST:/api/Sms/CalculateSmsAmount
     * @secure
     */
    smsCalculateSmsAmountCreate: (
      data: CalculateSmsAmountCommand,
      params: RequestParams = {},
    ) =>
      this.request<SmsCalculateSmsAmountCreateData, FailedResponse>({
        path: `/api/Sms/CalculateSmsAmount`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sms
     * @name SmsCalculateSmsGroupAmountCreate
     * @request POST:/api/Sms/CalculateSmsGroupAmount
     * @secure
     */
    smsCalculateSmsGroupAmountCreate: (
      data: CalculateSmsGroupAmountCommand,
      params: RequestParams = {},
    ) =>
      this.request<SmsCalculateSmsGroupAmountCreateData, FailedResponse>({
        path: `/api/Sms/CalculateSmsGroupAmount`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sms
     * @name SmsCalculateSmsSpecialGroupAmountCreate
     * @request POST:/api/Sms/CalculateSmsSpecialGroupAmount
     * @secure
     */
    smsCalculateSmsSpecialGroupAmountCreate: (
      data: CalculateSmsSpecialGroupAmountCommand,
      params: RequestParams = {},
    ) =>
      this.request<SmsCalculateSmsSpecialGroupAmountCreateData, FailedResponse>(
        {
          path: `/api/Sms/CalculateSmsSpecialGroupAmount`,
          method: "POST",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags Sms
     * @name SmsSendRequestList
     * @request GET:/api/Sms/SendRequest
     * @secure
     */
    smsSendRequestList: (
      query: SmsSendRequestListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<SmsSendRequestListData, FailedResponse>({
        path: `/api/Sms/SendRequest`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sms
     * @name SmsSendRequestCreate
     * @request POST:/api/Sms/SendRequest
     * @secure
     */
    smsSendRequestCreate: (
      data: SendSmsRequestCommand,
      params: RequestParams = {},
    ) =>
      this.request<SmsSendRequestCreateData, FailedResponse>({
        path: `/api/Sms/SendRequest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sms
     * @name SmsSendRequestGroupCreate
     * @request POST:/api/Sms/SendRequestGroup
     * @secure
     */
    smsSendRequestGroupCreate: (
      data: SendSmsRequestGroupCommand,
      params: RequestParams = {},
    ) =>
      this.request<SmsSendRequestGroupCreateData, FailedResponse>({
        path: `/api/Sms/SendRequestGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sms
     * @name SmsSendRequestSpecialGroupCreate
     * @request POST:/api/Sms/SendRequestSpecialGroup
     * @secure
     */
    smsSendRequestSpecialGroupCreate: (
      data: SendSmsRequestSpecialGroupCommand,
      params: RequestParams = {},
    ) =>
      this.request<SmsSendRequestSpecialGroupCreateData, FailedResponse>({
        path: `/api/Sms/SendRequestSpecialGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sms
     * @name SmsCalculateSmartAudienceAmountCreate
     * @request POST:/api/Sms/CalculateSmartAudienceAmount
     * @secure
     */
    smsCalculateSmartAudienceAmountCreate: (
      data: CalculateSmartAudienceAmountCommand,
      params: RequestParams = {},
    ) =>
      this.request<SmsCalculateSmartAudienceAmountCreateData, FailedResponse>({
        path: `/api/Sms/CalculateSmartAudienceAmount`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sms
     * @name SmsSendRequestSmartAudienceCreate
     * @request POST:/api/Sms/SendRequestSmartAudience
     * @secure
     */
    smsSendRequestSmartAudienceCreate: (
      data: SendSmsRequestSmartAudienceCommand,
      params: RequestParams = {},
    ) =>
      this.request<SmsSendRequestSmartAudienceCreateData, FailedResponse>({
        path: `/api/Sms/SendRequestSmartAudience`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sms
     * @name SmsCalculateSmartAudienceDiscountAmountCreate
     * @request POST:/api/Sms/CalculateSmartAudienceDiscountAmount
     * @secure
     */
    smsCalculateSmartAudienceDiscountAmountCreate: (
      data: SmartAudienceDiscountCommand,
      params: RequestParams = {},
    ) =>
      this.request<
        SmsCalculateSmartAudienceDiscountAmountCreateData,
        FailedResponse
      >({
        path: `/api/Sms/CalculateSmartAudienceDiscountAmount`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sms
     * @name SmsSendSmartAudienceDiscountCreate
     * @request POST:/api/Sms/SendSmartAudienceDiscount
     * @secure
     */
    smsSendSmartAudienceDiscountCreate: (
      data: SmartAudienceDiscountCommand,
      params: RequestParams = {},
    ) =>
      this.request<SmsSendSmartAudienceDiscountCreateData, FailedResponse>({
        path: `/api/Sms/SendSmartAudienceDiscount`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sms
     * @name SmsCalculateCustomersDiscountAmountCreate
     * @request POST:/api/Sms/CalculateCustomersDiscountAmount
     * @secure
     */
    smsCalculateCustomersDiscountAmountCreate: (
      data: CustomersDiscountCommand,
      params: RequestParams = {},
    ) =>
      this.request<
        SmsCalculateCustomersDiscountAmountCreateData,
        FailedResponse
      >({
        path: `/api/Sms/CalculateCustomersDiscountAmount`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sms
     * @name SmsSendCustomersDiscountCreate
     * @request POST:/api/Sms/SendCustomersDiscount
     * @secure
     */
    smsSendCustomersDiscountCreate: (
      data: CustomersDiscountCommand,
      params: RequestParams = {},
    ) =>
      this.request<SmsSendCustomersDiscountCreateData, FailedResponse>({
        path: `/api/Sms/SendCustomersDiscount`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SmsTemplate
     * @name SmsTemplateList
     * @request GET:/api/SmsTemplate
     * @secure
     */
    smsTemplateList: (
      query: SmsTemplateListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<SmsTemplateListData, FailedResponse>({
        path: `/api/SmsTemplate`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SmsTemplate
     * @name SmsTemplateCreate
     * @request POST:/api/SmsTemplate
     * @secure
     */
    smsTemplateCreate: (
      data: CreateMerchantSmsTemplateCommand,
      params: RequestParams = {},
    ) =>
      this.request<SmsTemplateCreateData, FailedResponse>({
        path: `/api/SmsTemplate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SmsTemplate
     * @name SmsTemplateUpdate
     * @request PUT:/api/SmsTemplate
     * @secure
     */
    smsTemplateUpdate: (
      data: UpdateMerchantSmsTemplateCommand,
      params: RequestParams = {},
    ) =>
      this.request<SmsTemplateUpdateData, FailedResponse>({
        path: `/api/SmsTemplate`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SmsTemplate
     * @name SmsTemplateDelete
     * @request DELETE:/api/SmsTemplate
     * @secure
     */
    smsTemplateDelete: (
      data: DeleteMerchantSmsTemplateCommand,
      params: RequestParams = {},
    ) =>
      this.request<SmsTemplateDeleteData, FailedResponse>({
        path: `/api/SmsTemplate`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Test
     * @name TestList
     * @request GET:/api/Test
     * @secure
     */
    testList: (params: RequestParams = {}) =>
      this.request<TestListData, any>({
        path: `/api/Test`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Test
     * @name TestGet222List
     * @request GET:/api/Test/get222
     * @secure
     */
    testGet222List: (params: RequestParams = {}) =>
      this.request<TestGet222ListData, any>({
        path: `/api/Test/get222`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transaction
     * @name TransactionList
     * @request GET:/api/Transaction
     * @secure
     */
    transactionList: (
      query: TransactionListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<TransactionListData, FailedResponse>({
        path: `/api/Transaction`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TransactionCredit
     * @name TransactionCreditCreate
     * @request POST:/api/TransactionCredit
     * @secure
     */
    transactionCreditCreate: (
      data: CreateTransactionCreditCommand,
      params: RequestParams = {},
    ) =>
      this.request<TransactionCreditCreateData, FailedResponse>({
        path: `/api/TransactionCredit`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TransactionCredit
     * @name TransactionCreditList
     * @request GET:/api/TransactionCredit
     * @secure
     */
    transactionCreditList: (
      query: TransactionCreditListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<TransactionCreditListData, FailedResponse>({
        path: `/api/TransactionCredit`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkSchedule
     * @name B2CWorkScheduleList
     * @request GET:/api/b2c/WorkSchedule
     * @secure
     */
    b2CWorkScheduleList: (
      query: B2CWorkScheduleListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<B2CWorkScheduleListData, FailedResponse>({
        path: `/api/b2c/WorkSchedule`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkSchedule
     * @name WorkScheduleList
     * @request GET:/api/WorkSchedule
     * @secure
     */
    workScheduleList: (
      query: WorkScheduleListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<WorkScheduleListData, FailedResponse>({
        path: `/api/WorkSchedule`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkSchedule
     * @name WorkScheduleCreate
     * @request POST:/api/WorkSchedule
     * @secure
     */
    workScheduleCreate: (
      data: AddWorkScheduleCommand,
      params: RequestParams = {},
    ) =>
      this.request<WorkScheduleCreateData, FailedResponse>({
        path: `/api/WorkSchedule`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
